import * as React from 'react';
import React__default, { useState, useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { ScrollIntoView, Alert, Link, Button, RichTextArea, LoaderScreen, CheckboxList, MediaQuery, SkeletonLoader, Flyout, toast } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { Form, Email, Password, Util, PasswordWithStrengthIndicator, DateOfBirthSelect } from '@grandvisionhq/forms';
import { uninitState, idleState, connect, useIntl, statusFailed, statusLoading, useSelector, useDispatch, withIntl, statusSuccess, failedState, loadingState, successState, ReducersRegistry, SagaRegistry } from '@grandvisionhq/state';
import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { createBrowserHistory } from 'history';
import { gql, useMutation } from '@grandvisionhq/graphql';
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import { parseHtml, isModifiedClickEvent, LocaleUtils, QueryString, StringGuard, isString } from '@grandvisionhq/utils';
import { Icon } from '@grandvisionhq/icons';
import { takeLatest, put, call, select, takeLeading, all } from 'redux-saga/effects';
import { WebAuth } from 'auth0-js';
import { channel, buffers } from 'redux-saga';
import jwtDecode from 'jwt-decode';
import { Type, optional, verify } from 'specified';
import { DataLayer } from '@grandvisionhq/analytics';
import { Customers } from '@grandvisionhq/api-client';

var SIGNUP = 'my-account/create/signup';
var SIGNUP_SUCCESS = 'my-account/create/sign-success';
var SIGNUP_FAILED = 'my-account/create/signup-failed';
var SET_PASSWORD$1 = 'my-account/create/set-password';
var SET_PASSWORD_SUCCESS = 'my-account/create/set-password-success';
var SET_PASSWORD_FAILED = 'my-account/create/set-password-failed';
var signup = function (payload) { return ({
    type: SIGNUP,
    payload: payload,
}); };
var signUpSuccess = function (payload) { return ({
    type: SIGNUP_SUCCESS,
    payload: payload,
}); };
var signUpFailed = function (error) { return ({
    type: SIGNUP_FAILED,
    error: error,
}); };
var setPassword = function (payload) { return ({
    type: SET_PASSWORD$1,
    payload: payload,
}); };
var setPasswordSuccess = function (payload) { return ({
    type: SET_PASSWORD_SUCCESS,
    payload: payload,
}); };
var setPasswordFailed = function (error) { return ({
    type: SET_PASSWORD_FAILED,
    error: error,
}); };

var actions$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SIGNUP: SIGNUP,
  SIGNUP_SUCCESS: SIGNUP_SUCCESS,
  SIGNUP_FAILED: SIGNUP_FAILED,
  SET_PASSWORD: SET_PASSWORD$1,
  SET_PASSWORD_SUCCESS: SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILED: SET_PASSWORD_FAILED,
  signup: signup,
  signUpSuccess: signUpSuccess,
  signUpFailed: signUpFailed,
  setPassword: setPassword,
  setPasswordSuccess: setPasswordSuccess,
  setPasswordFailed: setPasswordFailed
});

var LOGIN = 'account/login';
var LOGIN_FAILED = 'account/login_failed';
var PARSE_HASH = 'account/login/parse-hash';
var PARSE_HASH_FAILED = 'account/login/parse-hash-failed';
var PARSE_HASH_SUCCEEDED = 'account/login_success';
var RECOVER_SESSION = 'account/login/recover-session';
var RECOVER_SESSION_FAILED = 'account/login/recover-session-failed';
var loginWithPassword = function (payload) { return ({
    type: LOGIN,
    payload: payload,
}); };
var parseHash$2 = function () { return ({ type: PARSE_HASH }); };
var parseHashFailed = function (payload) { return ({
    type: PARSE_HASH_FAILED,
    payload: payload,
}); };
var parseHashSucceeded = function (payload) { return ({
    type: PARSE_HASH_SUCCEEDED,
    payload: payload,
}); };
var loginFailed = function (error) { return ({
    type: LOGIN_FAILED,
    error: error,
}); };
var recoverSession$1 = function () { return ({
    type: RECOVER_SESSION,
}); };
var recoverSessionFailed = function (error) { return ({
    type: RECOVER_SESSION_FAILED,
    error: error,
}); };

var actions$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LOGIN: LOGIN,
  LOGIN_FAILED: LOGIN_FAILED,
  PARSE_HASH: PARSE_HASH,
  PARSE_HASH_FAILED: PARSE_HASH_FAILED,
  PARSE_HASH_SUCCEEDED: PARSE_HASH_SUCCEEDED,
  RECOVER_SESSION: RECOVER_SESSION,
  RECOVER_SESSION_FAILED: RECOVER_SESSION_FAILED,
  loginWithPassword: loginWithPassword,
  parseHash: parseHash$2,
  parseHashFailed: parseHashFailed,
  parseHashSucceeded: parseHashSucceeded,
  loginFailed: loginFailed,
  recoverSession: recoverSession$1,
  recoverSessionFailed: recoverSessionFailed
});

var LOG_OUT = 'account/log_out';
var LOGGED_OUT = 'account/logged_out';
var logOut$1 = function () { return ({
    type: LOG_OUT,
}); };
var loggedOut = function () { return ({
    type: LOGGED_OUT,
}); };

var actions$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LOG_OUT: LOG_OUT,
  LOGGED_OUT: LOGGED_OUT,
  logOut: logOut$1,
  loggedOut: loggedOut
});

var FETCH_OPT_INS = 'opt-ins/fetch-opt-ins';
var FETCH_OPT_INS_SUCCESS = 'opt-ins/fetch-opt-ins-success';
var FETCH_OPT_INS_FAILED = 'opt-ins/fetch-opt-ins-failed';
var TOGGLE_OPT_INS = 'opt-ins/toggle-opt-ins';
var UPDATE_OPT_INS = 'opt-ins/update-opt-ins';
var UPDATE_OPT_INS_SUCCESS = 'opt-ins/update-opt-ins-success';
var UPDATE_OPT_INS_FAILED = 'opt-ins/update-opt-ins-failed';
var toggleOptIns = function (payload) { return ({
    type: TOGGLE_OPT_INS,
    payload: payload,
}); };
var fetchOptIns$1 = function () { return ({
    type: FETCH_OPT_INS,
}); };
var fetchOptInsSuccess = function (payload) { return ({
    type: FETCH_OPT_INS_SUCCESS,
    payload: payload,
}); };
var fetchOptInsFailed = function (error) { return ({
    type: FETCH_OPT_INS_FAILED,
    error: error,
}); };
var updateOptIns$1 = function (payload) { return ({
    type: UPDATE_OPT_INS,
    payload: payload,
}); };
var updateOptInsSuccess = function () { return ({
    type: UPDATE_OPT_INS_SUCCESS,
}); };
var updateOptInsFailed = function (error) { return ({
    type: UPDATE_OPT_INS_FAILED,
    error: error,
}); };

var actions$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_OPT_INS: FETCH_OPT_INS,
  FETCH_OPT_INS_SUCCESS: FETCH_OPT_INS_SUCCESS,
  FETCH_OPT_INS_FAILED: FETCH_OPT_INS_FAILED,
  TOGGLE_OPT_INS: TOGGLE_OPT_INS,
  UPDATE_OPT_INS: UPDATE_OPT_INS,
  UPDATE_OPT_INS_SUCCESS: UPDATE_OPT_INS_SUCCESS,
  UPDATE_OPT_INS_FAILED: UPDATE_OPT_INS_FAILED,
  toggleOptIns: toggleOptIns,
  fetchOptIns: fetchOptIns$1,
  fetchOptInsSuccess: fetchOptInsSuccess,
  fetchOptInsFailed: fetchOptInsFailed,
  updateOptIns: updateOptIns$1,
  updateOptInsSuccess: updateOptInsSuccess,
  updateOptInsFailed: updateOptInsFailed
});

var RESET_PASSWORD = 'account/reset-password/reset-password';
var RESET_PASSWORD_SUCCESS = 'account/reset-password/reset-password-success';
var RESET_PASSWORD_FAILED = 'account/reset-password/reset-password-failed';
var UPDATE_PASSWORD = 'account/reset-password/update-password';
var UPDATE_PASSWORD_FAILED = 'account/reset-password/update-password-failed';
var UPDATE_PASSWORD_SUCCESS = 'account/reset-password/update-password-success';
var CHANGE_PASSWORD = 'account/reset-password/change-password';
var CHANGE_PASSWORD_FAILED = 'account/reset-password/change-password-failed';
var CHANGE_PASSWORD_SUCCESS = 'account/reset-password/change-password-success';
var resetPassword = function (payload) { return ({
    type: RESET_PASSWORD,
    payload: payload,
}); };
var resetPasswordSuccess = function (payload) { return ({
    type: RESET_PASSWORD_SUCCESS,
    payload: payload,
}); };
var resetPasswordFailed = function (error) { return ({
    type: RESET_PASSWORD_FAILED,
    error: error,
}); };
var updatePassword = function (payload) { return ({
    type: UPDATE_PASSWORD,
    payload: payload,
}); };
var updatePasswordFailed = function (error) { return ({
    type: UPDATE_PASSWORD_FAILED,
    error: error,
}); };
var updatePasswordSuccess = function (payload) { return ({
    type: UPDATE_PASSWORD_SUCCESS,
    payload: payload,
}); };
var changePassword = function (payload) { return ({
    type: CHANGE_PASSWORD,
    payload: payload,
}); };
var changePasswordFailed = function (error) { return ({
    type: CHANGE_PASSWORD_FAILED,
    error: error,
}); };
var changePasswordSuccess = function (payload) { return ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload: payload,
}); };

var actions$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RESET_PASSWORD: RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS: RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILED: RESET_PASSWORD_FAILED,
  UPDATE_PASSWORD: UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAILED: UPDATE_PASSWORD_FAILED,
  UPDATE_PASSWORD_SUCCESS: UPDATE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD: CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILED: CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS: CHANGE_PASSWORD_SUCCESS,
  resetPassword: resetPassword,
  resetPasswordSuccess: resetPasswordSuccess,
  resetPasswordFailed: resetPasswordFailed,
  updatePassword: updatePassword,
  updatePasswordFailed: updatePasswordFailed,
  updatePasswordSuccess: updatePasswordSuccess,
  changePassword: changePassword,
  changePasswordFailed: changePasswordFailed,
  changePasswordSuccess: changePasswordSuccess
});

var FETCH_USER_DATA = 'auth/fetch-user-data';
var FETCH_USER_DATA_FAILED = 'auth/fetch-user-data-failed';
var FETCH_USER_DATA_SUCCESS = 'auth/fetch-user-data-success';
var UPDATE_USER_DATA = 'auth/update-user-data';
var UPDATE_USER_DATA_FAILED = 'auth/update-user-data-failed';
var UPDATE_USER_DATA_SUCCESS = 'auth/update-user-data-success';
var fetchUserData$1 = function () { return ({
    type: FETCH_USER_DATA,
}); };
var fetchUserDataFailed = function (error) { return ({
    type: FETCH_USER_DATA_FAILED,
    error: error,
}); };
var fetchUserDataSuccess = function (payload) { return ({
    type: FETCH_USER_DATA_SUCCESS,
    payload: payload,
}); };
var updateUserData$1 = function (payload) { return ({
    type: UPDATE_USER_DATA,
    payload: payload,
}); };
var updateUserDataFailed = function (payload) { return ({
    type: UPDATE_USER_DATA_FAILED,
    payload: payload,
}); };
var updateUserDataSuccess = function (payload) { return ({
    type: UPDATE_USER_DATA_SUCCESS,
    payload: payload,
}); };

var actions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_USER_DATA: FETCH_USER_DATA,
  FETCH_USER_DATA_FAILED: FETCH_USER_DATA_FAILED,
  FETCH_USER_DATA_SUCCESS: FETCH_USER_DATA_SUCCESS,
  UPDATE_USER_DATA: UPDATE_USER_DATA,
  UPDATE_USER_DATA_FAILED: UPDATE_USER_DATA_FAILED,
  UPDATE_USER_DATA_SUCCESS: UPDATE_USER_DATA_SUCCESS,
  fetchUserData: fetchUserData$1,
  fetchUserDataFailed: fetchUserDataFailed,
  fetchUserDataSuccess: fetchUserDataSuccess,
  updateUserData: updateUserData$1,
  updateUserDataFailed: updateUserDataFailed,
  updateUserDataSuccess: updateUserDataSuccess
});

var INIT = 'auth/init';
var GOTO = 'auth/goto';
var init$1 = function (payload) { return ({
    type: INIT,
    payload: payload,
}); };
var goto = function (payload) { return ({
    type: GOTO,
    payload: payload,
}); };

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CreateAccountActions: actions$6,
  OptInsActions: actions$3,
  UserDataActions: actions$1,
  LoginActions: actions$5,
  LogoutActions: actions$4,
  ResetPasswordActions: actions$2,
  INIT: INIT,
  GOTO: GOTO,
  init: init$1,
  goto: goto
});

var RouteKey;
(function (RouteKey) {
    RouteKey["AddressBook"] = "addressBook";
    RouteKey["Appointments"] = "appointments";
    RouteKey["ChangePassword"] = "changePassword";
    RouteKey["CreateAccount"] = "createAccount";
    RouteKey["LinkExpired"] = "linkExpired";
    RouteKey["Login"] = "login";
    RouteKey["Logout"] = "logout";
    RouteKey["Orders"] = "orders";
    RouteKey["Prescriptions"] = "prescriptions";
    RouteKey["Privacy"] = "privacy";
    RouteKey["Profile"] = "profile";
    RouteKey["ResetPassword"] = "resetPassword";
    RouteKey["SetPassword"] = "setPassword";
    RouteKey["Signup"] = "signup";
    RouteKey["Subscriptions"] = "subscriptions";
    RouteKey["SubscriptionsV2"] = "subscriptionsv2";
    RouteKey["UnlinkAppointment"] = "unlinkAppointment";
    RouteKey["UnlinkOrder"] = "unlinkOrder";
    RouteKey["Verify"] = "verify";
})(RouteKey || (RouteKey = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

/**
 * This represents all states the auth package can be in
 */
var AuthState;
(function (AuthState) {
    AuthState["Uninitialized"] = "uninitialized";
    AuthState["Initialized"] = "initialized";
    AuthState["LoggedIn"] = "logged-in";
    AuthState["LoggedOut"] = "logged-out";
    AuthState["ParseHashFailed"] = "parse-hash-failed";
})(AuthState || (AuthState = {}));
function getLoggedInState(auth) {
    if (!auth || isUninitialized$1(auth) || isInitialized$1(auth)) {
        return 'loading';
    }
    if (isLoggedIn$1(auth)) {
        return AuthState.LoggedIn;
    }
    return AuthState.LoggedOut;
}
var isState = function (stateName) { return function (state) {
    return state.state === stateName;
}; };
var isUninitialized$1 = isState(AuthState.Uninitialized);
var isInitialized$1 = isState(AuthState.Initialized);
var isLoggedInPasswordless = function (state) {
    return state.state === AuthState.LoggedIn && state.type === 'passwordless';
};
var isLoggedIn$1 = function (state) {
    return state.state === AuthState.LoggedIn && state.type === 'regular';
};
var isParseHashFailed = isState(AuthState.ParseHashFailed);
var isLoggedOut$1 = isState(AuthState.LoggedOut);

var state = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AuthState () { return AuthState; },
  getLoggedInState: getLoggedInState,
  isUninitialized: isUninitialized$1,
  isInitialized: isInitialized$1,
  isLoggedInPasswordless: isLoggedInPasswordless,
  isLoggedIn: isLoggedIn$1,
  isParseHashFailed: isParseHashFailed,
  isLoggedOut: isLoggedOut$1
});

var getAuth = function (state) { return state.auth; };
/**
 * This will return true for all states except uninitialized
 */
var isInitialized = createSelector(getAuth, function (auth) { return auth && !isUninitialized$1(auth); });
var isUninitialized = createSelector(getAuth, function (auth) {
    return isUninitialized$1(auth);
});
var isLoggedIn = createSelector(getAuth, function (auth) { return auth && auth.state === AuthState.LoggedIn; });
var isLoggedOut = createSelector(getAuth, function (auth) { return auth && auth.state === AuthState.LoggedOut; });
var getRouting = createSelector(getAuth, function (auth) { return (isUninitialized$1(auth) ? undefined : auth.routing); });
var getRoutes = createSelector(getRouting, function (routing) {
    return routing ? routing.routes : undefined;
});
var getBasePath = createSelector(getRouting, function (routing) {
    return routing ? routing.basePath : undefined;
});
var getCheckoutRoute = createSelector(getRouting, function (routing) { return (routing ? routing.checkoutRoute : undefined); });
var getFormattedRoutes = createSelector(getRoutes, getBasePath, function (routes, basePath) {
    if (!routes || !basePath) {
        return undefined;
    }
    return Object.entries(routes).reduce(function (formattedRoutes, _a) {
        var _b;
        var _c = __read(_a, 2), name = _c[0], route = _c[1];
        return (__assign((_b = {}, _b[name] = "/" + basePath + "/" + route, _b), formattedRoutes));
    }, {});
});
var getDomain = createSelector(isInitialized, getAuth, function (isInitialized, auth) {
    return isInitialized ? auth.domain : undefined;
});
var getCustomDomain = createSelector(isInitialized, getAuth, function (isInitialized, auth) {
    return isInitialized ? auth.customDomain : undefined;
});
var getUserId = createSelector(getAuth, function (auth) {
    return isLoggedIn$1(auth) ? auth.userId : undefined;
});
/**
 * Opt-In selectors
 */
var getOptIns = createSelector(getAuth, function (auth) {
    return !isUninitialized$1(auth) ? auth.optIns : [];
});
var getOptInsForSignup = createSelector(getOptIns, function (optIns) {
    return optIns.filter(function (o) { return o.isInSignup; });
});
var getUserSettings = createSelector(getAuth, function (auth) { return (isLoggedIn$1(auth) ? auth.userSettings : undefined); });
var getChangedOptIns = createSelector(getUserSettings, function (userSettings) {
    return userSettings ? userSettings.optInsState.changedOptIns : {};
});
var getOptInsOnServer = createSelector(getUserSettings, function (userSettings) {
    return userSettings ? userSettings === null || userSettings === void 0 ? void 0 : userSettings.optInsState.optInsOnServer : uninitState();
});
var getUpdateOptInsCall = createSelector(getUserSettings, function (userSettings) {
    return userSettings ? userSettings.optInsState.updateOptInsCall : idleState();
});
var getUserDataState = createSelector(getUserSettings, function (userSettings) { return userSettings === null || userSettings === void 0 ? void 0 : userSettings.userDataState; });
var getUserData = createSelector(getUserDataState, function (userDataState) {
    return userDataState === null || userDataState === void 0 ? void 0 : userDataState.userData;
});
var getCallStatus = createSelector(getUserDataState, function (userDataState) {
    return userDataState === null || userDataState === void 0 ? void 0 : userDataState.updateCalls;
});

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAuth: getAuth,
  isInitialized: isInitialized,
  isUninitialized: isUninitialized,
  isLoggedIn: isLoggedIn,
  isLoggedOut: isLoggedOut,
  getRouting: getRouting,
  getRoutes: getRoutes,
  getBasePath: getBasePath,
  getCheckoutRoute: getCheckoutRoute,
  getFormattedRoutes: getFormattedRoutes,
  getDomain: getDomain,
  getCustomDomain: getCustomDomain,
  getUserId: getUserId,
  getOptIns: getOptIns,
  getOptInsForSignup: getOptInsForSignup,
  getUserSettings: getUserSettings,
  getChangedOptIns: getChangedOptIns,
  getOptInsOnServer: getOptInsOnServer,
  getUpdateOptInsCall: getUpdateOptInsCall,
  getUserDataState: getUserDataState,
  getUserData: getUserData,
  getCallStatus: getCallStatus
});

var LABEL_PREFIX = 'account.login';
var ERROR_PREFIX = LABEL_PREFIX + ".errors";
var Auth0ErrorCode;
(function (Auth0ErrorCode) {
    Auth0ErrorCode["AccessDenied"] = "access_denied";
    Auth0ErrorCode["PasswordLeaked"] = "password_leaked";
})(Auth0ErrorCode || (Auth0ErrorCode = {}));
var UrlStateParamError;
(function (UrlStateParamError) {
    UrlStateParamError["RequiresPasswordChange"] = "requiresPasswordChange";
})(UrlStateParamError || (UrlStateParamError = {}));
var NonCompliantPasswordMessage = function (props) {
    var routes = props.routes;
    var getLabel = useIntl().getLabel;
    var label = getLabel(ERROR_PREFIX + ".requiresPasswordChange");
    var handleClick = React.useCallback(function () {
        props.resetPassword({ email: props.email || '' });
    }, [props.resetPassword, props.email]);
    /*
     * Look for the [ ] and take the part before, inside and after to create a text with
     * the link inside, like: "before" + <a>"inside"<a/> + "after"
     */
    var regex = /(.+)\[(.+)\](.+)/g;
    var linkElement = props.email ? (React.createElement("button", { className: "login__reset-link", onClick: handleClick, "data-t": "non-compliant-password-action" }, label.replace(regex, '$2'))) : (React.createElement("a", { className: "login__reset-link", href: routes ? routes.resetPassword : '#', "data-t": "non-compliant-password-action" }, label.replace(regex, '$2')));
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, label.replace(regex, '$1')),
        linkElement,
        React.createElement("span", null, label.replace(regex, '$3'))));
};
NonCompliantPasswordMessage.displayName = 'NonCompliantPasswordMessage';
var initialFieldState = {
    isTouched: false,
    isValid: false,
    value: '',
};
var Login = function (_a) {
    var auth = _a.auth, email = _a.email, error = _a.error, routes = _a.routes, className = _a.className, loginWithPassword = _a.loginWithPassword, createAccountRichText = _a.createAccountRichText, disableSignup = _a.disableSignup, returnPath = _a.returnPath, resetPassword = _a.resetPassword;
    var getLabel = useIntl().getLabel;
    var _b = __read(React.useState(false), 2), hasFormValidationError = _b[0], setHasFormValidationError = _b[1];
    var _c = __read(React.useState({
        email: __assign({ name: 'email' }, initialFieldState),
        password: __assign({ name: 'password' }, initialFieldState),
    }), 2), loginForm = _c[0], setLoginForm = _c[1];
    var formattedError = React.useMemo(function () {
        if (statusFailed(auth.loginCall)) {
            var _a = auth.loginCall.error, code = _a.code, error_description = _a.error_description, message = _a.message;
            if (code === Auth0ErrorCode.AccessDenied) {
                return getLabel(ERROR_PREFIX + ".invalidCredentials");
            }
            if (code === Auth0ErrorCode.PasswordLeaked) {
                return getLabel(ERROR_PREFIX + ".passwordLeaked");
            }
            return error_description || message || '';
        }
        if (error === UrlStateParamError.RequiresPasswordChange) {
            return;
        }
        // If this is true, it is one of the other errors from the URL state parameter
        if (typeof error === 'string') {
            return getLabel(ERROR_PREFIX + "." + error);
        }
        if (hasFormValidationError) {
            return getLabel(ERROR_PREFIX + ".formValidation");
        }
    }, [error, auth.loginCall, getLabel, hasFormValidationError]);
    var handleSubmit = React.useCallback(function (state) {
        var _a, _b, _c, _d;
        var formState = state.formState;
        if (((_a = formState === null || formState === void 0 ? void 0 : formState.email) === null || _a === void 0 ? void 0 : _a.isValid) && ((_b = formState === null || formState === void 0 ? void 0 : formState.password) === null || _b === void 0 ? void 0 : _b.isValid)) {
            setHasFormValidationError(false);
            loginWithPassword({
                email: formState.email.value,
                password: formState.password.value,
                returnPath: returnPath,
            });
        }
        if (!((_c = formState === null || formState === void 0 ? void 0 : formState.email) === null || _c === void 0 ? void 0 : _c.isTouched) || !((_d = formState === null || formState === void 0 ? void 0 : formState.password) === null || _d === void 0 ? void 0 : _d.isTouched)) {
            return setLoginForm({
                email: __assign(__assign({}, formState.email), { isTouched: true }),
                password: __assign(__assign({}, formState.password), { isTouched: true }),
            });
        }
        setHasFormValidationError(true);
    }, [loginWithPassword, returnPath, hasFormValidationError, setHasFormValidationError, setLoginForm]);
    var wrapperClasses = classnames('login', className);
    var isLoading = statusLoading(auth.loginCall);
    return (React.createElement("div", { className: wrapperClasses },
        React.createElement(React.Fragment, null,
            React.createElement("section", { className: "login__section" },
                React.createElement(Heading, { variant: "medium", className: "login__section__title" }, getLabel(LABEL_PREFIX + ".title")),
                !isLoading && formattedError && (React.createElement(ScrollIntoView, { key: formattedError },
                    React.createElement(Alert, { type: "error", icon: "info", message: formattedError }))),
                error === UrlStateParamError.RequiresPasswordChange && (React.createElement(ScrollIntoView, { key: error },
                    React.createElement(Alert, { type: "warning", icon: "info", className: "login__non-compliancy-alert" },
                        React.createElement(NonCompliantPasswordMessage, { routes: routes, resetPassword: resetPassword, email: email })))),
                React.createElement(Form, { onSubmit: handleSubmit, initialFormState: loginForm, name: "login", "data-t": "login-form", showErrorsOnInvalidSubmit: false },
                    React.createElement(Email, { "data-t": "email", required: true, label: getLabel('fields.input.email.label'), errorMessage: getLabel('fields.input.email.errorMessage'), hideAsteriskSign: true }),
                    React.createElement(Password, { "data-t": "password", required: true, label: getLabel('fields.input.password.label'), errorMessage: getLabel('fields.input.password.errorMessage'), hideAsteriskSign: true }),
                    React.createElement(Link, { className: "login__forgot-password", label: getLabel('account.action.resetPassword'), url: routes ? routes.resetPassword : '#' }),
                    React.createElement(Button, { "data-t": "submit", type: "submit", isLoading: isLoading, caption: getLabel('account.action.login'), className: "login__button" }))),
            !disableSignup && (React.createElement("section", { className: "login__section" },
                createAccountRichText && React.createElement(RichTextArea, { content: createAccountRichText }),
                React.createElement(Button, { "data-t": "create-account", variant: "outline", caption: getLabel('account.action.createAccount'), className: "login__button login__button--signup", href: routes ? routes.signup : '#' }))))));
};
var mapStateToProps$3 = function (state) { return ({
    auth: getAuth(state),
    routes: getFormattedRoutes(state),
}); };
var mapDispatchToProps$4 = {
    loginWithPassword: loginWithPassword,
    resetPassword: resetPassword,
};
var Login$1 = connect(mapStateToProps$3, mapDispatchToProps$4)(Login);

var EmailForm = /** @class */ (function (_super) {
    __extends(EmailForm, _super);
    function EmailForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            email: {
                value: '',
                isValid: undefined,
            },
        };
        _this.setEmail = function (state) {
            _this.setState(function () { return ({
                email: {
                    value: state.value,
                    isValid: state.isValid,
                },
            }); });
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            var email = _this.state.email;
            var onSubmit = _this.props.onSubmit;
            if (email.isValid === true) {
                onSubmit(email.value);
            }
        };
        return _this;
    }
    EmailForm.prototype.render = function () {
        var email = this.state.email;
        var _a = this.props, dataT = _a.dataT, buttonLabel = _a.buttonLabel, isButtonDisabled = _a.isButtonDisabled, isButtonLoading = _a.isButtonLoading, className = _a.className, children = _a.children, emailLabel = _a.emailLabel, emailErrorLabel = _a.emailErrorLabel, renderOptIns = _a.renderOptIns;
        return (React.createElement("form", { onSubmit: this.handleSubmit, className: classnames('email-form', className), noValidate: true, "data-t": dataT },
            React.createElement(Email, { "data-t": "email", required: true, label: emailLabel, errorMessage: emailErrorLabel, onChange: this.setEmail, hideAsteriskSign: true }),
            renderOptIns,
            React.createElement(Button, { "data-t": "submit", type: "submit", disabled: isButtonDisabled || !email.isValid, isLoading: isButtonLoading, caption: buttonLabel, className: "email-form__button" }),
            children));
    };
    return EmailForm;
}(React.Component));

var createOptInsUpdate = function (optIns) {
    if (optIns === void 0) { optIns = {}; }
    if (isEmpty(optIns)) {
        return undefined;
    }
    return Object.keys(optIns).reduce(function (m, optInName) {
        var _a;
        return (__assign(__assign({}, m), (_a = {}, _a[optInName] = {
            value: optIns[optInName].checked,
            uiType: 'checkbox',
            literalText: optIns[optInName].label,
        }, _a)));
    }, {});
};

var FormName;
(function (FormName) {
    FormName["personalDetails"] = "personalDetails";
    FormName["billingAddress"] = "billingAddress";
    FormName["preferredStore"] = "preferredStore";
    FormName["signUp"] = "signUp";
})(FormName || (FormName = {}));

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get FormName () { return FormName; }
});

var getParsedDataFromLS = function () {
    try {
        var value = window.localStorage.getItem(FormName.personalDetails);
        if (value !== null && value !== 'undefined' && value !== '' && value.trim() !== '') {
            var returnValue = JSON.parse(value);
            if (typeof returnValue !== 'object') {
                return undefined;
            }
            if (Object.values(returnValue).some(function (v) { return typeof v !== 'string'; })) {
                return undefined;
            }
            return returnValue;
        }
        else {
            return undefined;
        }
    }
    catch (error) {
        console.error(error);
    }
};
var writeUserDataToLS = function (data) {
    try {
        window.localStorage.setItem(FormName.personalDetails, JSON.stringify(data));
    }
    catch (error) {
        console.error(error);
    }
};
var removeUserDataFromLS = function () {
    try {
        window.localStorage.removeItem(FormName.personalDetails);
    }
    catch (error) {
        console.error(error);
    }
};

var formatError = function (error) {
    if (!error) {
        return '';
    }
    // TODO: remove this and parse the rules so we can use bloomreach labels to format them
    if ('policy' in error && error.policy === 'string') {
        return error.policy.split(/\*\s?/);
    }
    if ('description' in error) {
        if (typeof error.description === 'string') {
            return error.description;
        }
        if (typeof error.description === 'object' && error.description.rules) {
            return error.description.rules.map(function (r) { return r.message; });
        }
    }
    if ('message' in error) {
        return error.message;
    }
    return '';
};

var getPasswordStrengthErrorLabel = function (error) {
    var passwordErrorCodes = ['password_strength_error', 'PasswordStrengthError'];
    // We don't get error codes from the backend
    if ('message' in error && passwordErrorCodes.some(function (code) { return error.message.includes(code); })) {
        return 'account.createAccount.setPassword.errors.passwordStrength';
    }
};

var _history;
var history = function () {
    if (!_history) {
        _history = createBrowserHistory();
    }
    return _history;
};

var parseAuth0StateParam = function (state) {
    var isPasswordless = false;
    var email;
    try {
        if (typeof state === 'string') {
            var statePayload = JSON.parse(state);
            if (typeof statePayload === 'object' && 'type' in statePayload && 'email' in statePayload) {
                isPasswordless = statePayload.type === 'passwordless';
                email = statePayload.email;
            }
        }
    }
    catch (_a) { }
    return {
        email: email,
        type: isPasswordless ? 'passwordless' : 'regular',
    };
};

// copied from auth0-js/src/helper/random.js
var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
function randomString(length) {
    var bytes = new Uint8Array(length);
    var result = [];
    var cryptoObj = 
    // eslint-disable-next-line @typescript-eslint/dot-notation
    'msCrypto' in window ? window['msCrypto'] : window.crypto;
    if (!cryptoObj) {
        return null;
    }
    var random = cryptoObj.getRandomValues(bytes);
    for (var a = 0; a < random.length; a++) {
        result.push(charset[random[a] % charset.length]);
    }
    return result.join('');
}

// Function needed to bypass IE11 'Invalid calling object' error
var redirect = function (route) { return window && window.location.assign(route); };

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createOptInsUpdate: createOptInsUpdate,
  getParsedDataFromLS: getParsedDataFromLS,
  writeUserDataToLS: writeUserDataToLS,
  removeUserDataFromLS: removeUserDataFromLS,
  formatError: formatError,
  getPasswordStrengthErrorLabel: getPasswordStrengthErrorLabel,
  history: history,
  parseAuth0StateParam: parseAuth0StateParam,
  randomString: randomString,
  redirect: redirect
});

var ExpiredLinkView = function (_a) {
    var onResend = _a.onResend, titleLabelKey = _a.titleLabelKey, loginUrl = _a.loginUrl, isLoading = _a.isLoading, hasError = _a.hasError;
    var getLabel = useIntl().getLabel;
    var _b = __read(React.useState(false), 2), isEmailSent = _b[0], setIsEmailSent = _b[1];
    var error = React.useMemo(function () {
        return hasError ? new Error(getLabel('account.createAccount.signup.errors.general')) : undefined;
    }, [hasError, getLabel]);
    var handleSubmit = React.useCallback(function (email) {
        if ((isEmailSent && !hasError) || isLoading) {
            return;
        }
        onResend({ email: email });
        setIsEmailSent(true);
    }, [isEmailSent, hasError, isLoading, onResend]);
    var canResend = !isEmailSent || error;
    return (React.createElement("div", { className: "expired-link myaccount__section", "data-t": "expired-link" },
        React.createElement(Heading, { variant: "medium" }, getLabel(titleLabelKey)),
        React.createElement(Alert, { type: "info", title: getLabel('account.linkExpired.title'), message: getLabel('account.linkExpired.message') }),
        error && React.createElement(Alert, { type: "error", message: formatError(error) }),
        React.createElement(EmailForm, { onSubmit: handleSubmit, emailErrorLabel: getLabel('account.error.emailInvalid'), emailLabel: getLabel('fields.input.email.label'), buttonLabel: !canResend ? getLabel('account.action.emailSent') : getLabel('account.action.requestLink'), isButtonDisabled: !canResend, isButtonLoading: isLoading }),
        React.createElement("a", { href: loginUrl, "data-t": "to-login", className: "expired-link__text" }, getLabel('account.action.returnToLogin'))));
};

var ExpiredLink = function (_a) {
    var targetAction = _a.targetAction;
    var _b = useSelector(getAuth), resetPasswordCall = _b.resetPasswordCall, signupCall = _b.signupCall;
    var routes = useSelector(getFormattedRoutes);
    var loginUrl = (routes === null || routes === void 0 ? void 0 : routes.login) || '#';
    var dispatch = useDispatch();
    var expiredLinkProps = React.useMemo(function () {
        if (targetAction === 'forgotPassword') {
            return {
                onResend: function (payload) {
                    dispatch(resetPassword(payload));
                },
                titleLabelKey: 'account.resetPassword.submitEmailAddress.title',
                loginUrl: loginUrl,
                isLoading: statusLoading(resetPasswordCall),
                hasError: statusFailed(resetPasswordCall),
            };
        }
        else {
            return {
                onResend: function (payload) {
                    dispatch(signup(payload));
                },
                titleLabelKey: 'account.createAccount.title',
                loginUrl: loginUrl,
                isLoading: statusLoading(signupCall),
                hasError: statusFailed(signupCall),
            };
        }
    }, [
        targetAction,
        signupCall,
        resetPasswordCall,
        statusLoading,
        statusFailed,
        loginUrl,
        resetPassword,
        signup,
    ]);
    return React.createElement(ExpiredLinkView, __assign({}, expiredLinkProps));
};

var Callback = /** @class */ (function (_super) {
    __extends(Callback, _super);
    function Callback() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Callback.prototype.componentDidMount = function () {
        if (this.props.type === 'callback') {
            this.props.parseHash();
        }
        else {
            this.props.loggedOut();
        }
    };
    Callback.prototype.render = function () {
        return React.createElement(LoaderScreen, { height: 50 });
    };
    return Callback;
}(React.Component));

var LoggedIn = function (_a) {
    var auth = _a.auth, disableContinue = _a.disableContinue, onLogoutClick = _a.onLogoutClick, onContinueClick = _a.onContinueClick;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    return (React.createElement("div", { className: "logged-in__container" },
        React.createElement(Heading, { variant: "medium", className: "checkout-step__title logged-in__title" }, getLabel('account.alreadyLoggedIn.title')),
        React.createElement("p", null, getFormattedLabel('account.alreadyLoggedIn.text', {
            labelData: { email: auth.email },
        })),
        !disableContinue && (React.createElement(Button, { className: "logged-in__button logged-in__button-continue", "data-t": "continue", caption: getLabel('common.actions.continue'), onClick: onContinueClick })),
        React.createElement(Button, { className: "logged-in__button logged-in__button-logout", "data-t": "logout", caption: getLabel('account.action.logout'), onClick: onLogoutClick, variant: "outline" })));
};
var mapStateToProps$2 = function (state) { return ({
    auth: getAuth(state),
}); };
var mapDispatchToProps$3 = {
    onLogoutClick: logOut$1,
};
var LoggedIn$1 = connect(mapStateToProps$2, mapDispatchToProps$3)(LoggedIn);

var EmailSentConfirmation = /** @class */ (function (_super) {
    __extends(EmailSentConfirmation, _super);
    function EmailSentConfirmation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isEmailSent: false,
        };
        _this.replaceEmail = function (label, email) {
            return (label && label.replace('{{email}}', email)) || '';
        };
        _this.sendEmail = function () {
            _this.props.onResend({ email: _this.props.email });
            _this.setState({ isEmailSent: true });
        };
        return _this;
    }
    EmailSentConfirmation.prototype.render = function () {
        var _a = this.props, buttonCaption = _a.buttonCaption, className = _a.className, email = _a.email, firstParagraph = _a.firstParagraph, secondParagraph = _a.secondParagraph, title = _a.title;
        var error = formatError(this.props.error);
        var errorKey = typeof error === 'string' ? error : error.join(' ');
        return (React.createElement("div", { className: classnames('email-sent-confirmation', 'myaccount__section', className) },
            React.createElement(Heading, { variant: "medium" }, title),
            error && (React.createElement(ScrollIntoView, { key: errorKey },
                React.createElement(Alert, { type: "error", message: formatError(this.props.error) }))),
            React.createElement("p", { className: "email-sent-confirmation__text" }, this.replaceEmail(firstParagraph, email)),
            React.createElement("p", { className: "email-sent-confirmation__text" }, this.replaceEmail(secondParagraph, email)),
            React.createElement(Button, { "data-t": "re-send", className: "email-sent-confirmation__button", onClick: this.sendEmail, disabled: this.state.isEmailSent, caption: buttonCaption, variant: "outline" })));
    };
    return EmailSentConfirmation;
}(React.Component));

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var AccountOrigination;
(function (AccountOrigination) {
    AccountOrigination["IN_STORE"] = "IN_STORE";
    AccountOrigination["ONLINE"] = "ONLINE";
})(AccountOrigination || (AccountOrigination = {}));
/**
 * The reason for creating an account
 */
var AccountReason;
(function (AccountReason) {
    AccountReason["APPOINTMENT"] = "APPOINTMENT";
    AccountReason["ORDER"] = "ORDER";
    AccountReason["SIGN_UP"] = "SIGN_UP";
    AccountReason["SUBSCRIPTION"] = "SUBSCRIPTION";
})(AccountReason || (AccountReason = {}));
var AccountVerificationMethod;
(function (AccountVerificationMethod) {
    AccountVerificationMethod["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    AccountVerificationMethod["NONE"] = "NONE";
})(AccountVerificationMethod || (AccountVerificationMethod = {}));
var CreateAccountTargetAction;
(function (CreateAccountTargetAction) {
    CreateAccountTargetAction["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    CreateAccountTargetAction["SIGN_UP"] = "SIGN_UP";
})(CreateAccountTargetAction || (CreateAccountTargetAction = {}));
var UIType;
(function (UIType) {
    UIType["CHECKBOX"] = "CHECKBOX";
})(UIType || (UIType = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================

var CREATE_ACCOUNT = gql(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  mutation CreateB2CCustomerAccount($input: CreateB2CCustomerAccountInput!) {\n    createB2CCustomerAccount(input: $input) {\n      customerId\n    }\n  }\n"], ["\n  mutation CreateB2CCustomerAccount($input: CreateB2CCustomerAccountInput!) {\n    createB2CCustomerAccount(input: $input) {\n      customerId\n    }\n  }\n"])));
var templateObject_1$2;

var SET_PASSWORD = gql(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  mutation ActivateCustomerAccount($input: ActivateAccountInput!) {\n    activateCustomerAccount(input: $input) {\n      customerId\n    }\n  }\n"], ["\n  mutation ActivateCustomerAccount($input: ActivateAccountInput!) {\n    activateCustomerAccount(input: $input) {\n      customerId\n    }\n  }\n"])));
var templateObject_1$1;

// graphql endpoint wants iso format (yyyy-mm-dd)
var formatDateOfBirth = function (inDate) {
    var _a = __read(inDate.split('-'), 3), year = _a[0], month = _a[1], day = _a[2];
    return year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
};
var isFullPersonalDetails = function (input) {
    return !!(input.firstName && input.lastName && input.phone && input.customerDateOfBirth);
};
var formatPersonalDetails = function (input) { return ({
    firstName: input.firstName,
    lastName: input.lastName,
    phone: input.phone,
    salutation: input.salutation,
    dateOfBirth: input.customerDateOfBirth && formatDateOfBirth(input.customerDateOfBirth),
}); };
var formatOptIn = function (input) { return ({
    id: input.titleKey,
    literalText: input.value,
    uiType: UIType.CHECKBOX,
    value: true,
}); };
var useCreateAccount = function () {
    var _a;
    var _b = __read(useMutation(CREATE_ACCOUNT), 2), createAccount = _b[0], _c = _b[1], data = _c.data, loading = _c.loading, error = _c.error;
    var callback = function (_a) {
        var email = _a.email, optIns = _a.optIns, personalDetails = _a.personalDetails, loginRedirectUrl = _a.loginRedirectUrl;
        return createAccount({
            variables: {
                input: __assign(__assign({ email: email }, (personalDetails && isFullPersonalDetails(personalDetails)
                    ? { personalDetails: formatPersonalDetails(personalDetails) }
                    : {})), { optIns: optIns.map(formatOptIn), reason: AccountReason.SIGN_UP, accountMetaData: {
                        accountOrigination: AccountOrigination.ONLINE,
                        accountVerificationMethod: AccountVerificationMethod.NONE,
                    }, loginRedirectUrl: loginRedirectUrl }),
            },
        });
    };
    return [
        callback,
        {
            customerId: ((_a = data === null || data === void 0 ? void 0 : data.createB2CCustomerAccount) === null || _a === void 0 ? void 0 : _a.customerId) || '',
            loading: loading,
            error: error,
        },
    ];
};

var SignUpForm = function (_a) {
    var onSubmit = _a.onSubmit, className = _a.className, signUpForm = _a.signUpForm, renderOptIns = _a.renderOptIns, isButtonLoading = _a.isButtonLoading, buttonLabel = _a.buttonLabel, children = _a.children;
    var _b = __read(useState(Util.fieldsToFormState({ email: '' })), 2), formState = _b[0], setFormState = _b[1];
    var handleSubmit = function (formState) {
        var formValues = Util.getValuesFromState(formState.formState);
        onSubmit(formValues.email, pickBy(formValues, identity));
    };
    var handleChange = function (newState) {
        setFormState(newState.formState);
    };
    return (React__default.createElement(Form, { name: "signup-form", onSubmit: handleSubmit, initialFormState: formState, onChange: handleChange, className: classnames('signup-form', className) },
        React__default.createElement("fieldset", { className: "signup-form__fieldset" }, signUpForm),
        renderOptIns,
        React__default.createElement(Button, { "data-t": "submit", type: "submit", isLoading: isButtonLoading, caption: buttonLabel, className: "signup-form__button" }),
        children));
};

var SignUp = function (_a) {
    var labels = _a.labels, loginUrl = _a.loginUrl, onFormSubmit = _a.onFormSubmit, optIns = _a.optIns, signUpFields = _a.signUpFields, termsRichText = _a.termsRichText;
    return (React.createElement("div", { className: "signup" },
        React.createElement("section", { className: "signup__login-section" },
            React.createElement(Heading, { component: "h2", variant: "small" }, labels.hasAccount.title),
            React.createElement("p", { className: "signup__login-text" }, labels.hasAccount.text),
            React.createElement(Button, { className: "signup__login-button", caption: labels.actions.login, variant: "outline", "data-t": "to-login", href: loginUrl })),
        React.createElement("section", { className: "signup__signup-section" },
            React.createElement(Heading, { variant: "medium" }, labels.signup.title),
            React.createElement(SignUpForm, { "data-t": "signup-form", onSubmit: onFormSubmit, renderOptIns: optIns, signUpForm: signUpFields, buttonLabel: labels.actions.createAccount }, termsRichText && (React.createElement("div", { className: "signup__terms" },
                React.createElement(RichTextArea, { content: termsRichText })))),
            labels.dataConsent && (React.createElement(Text, { className: "signup__data-processing-disclaimer", variant: "caption" }, labels.dataConsent)))));
};

var SignUpContainer = function (_a) {
    var _b;
    var termsRichText = _a.termsRichText, loginUrl = _a.loginUrl, signUpFields = _a.signUpFields;
    var _c = useIntl(), getLabel = _c.getLabel, hasLabel = _c.hasLabel, getFormattedLabel = _c.getFormattedLabel;
    var auth = useSelector(getAuth);
    var availableOptIns = useSelector(getOptInsForSignup);
    var _d = __read(useCreateAccount(), 2), createAccount = _d[0], _e = _d[1]; _e.error; _e.loading; _e.customerId;
    var _f = window.location, protocol = _f.protocol, host = _f.host;
    var loginRedirectUrl = protocol + "//" + host + "/" + ((_b = auth.routing) === null || _b === void 0 ? void 0 : _b.basePath) + "/callback";
    var labels = {
        error: getLabel('account.createAccount.signup.errors.general'),
        dataConsent: hasLabel('account.consent.dataProcessing')
            ? getFormattedLabel('account.consent.dataProcessing', { parseLink: true })
            : undefined,
        hasAccount: {
            title: getLabel('account.hasAccount.title'),
            text: getLabel('account.hasAccount.text'),
        },
        signup: {
            title: getLabel('account.signup.title'),
        },
        actions: {
            login: getLabel('account.action.login'),
            createAccount: getLabel('account.action.createAccount'),
        },
    };
    var _g = __read(React.useState(function () { return ({ email: '' }); }), 2), userData = _g[0], setUserData = _g[1];
    var _h = __read(React.useState(false), 2), hasSignedUp = _h[0], setHasSignedUp = _h[1];
    var _j = __read(React.useState([]), 2), selectedOptIns = _j[0], setSelectedOptIns = _j[1];
    var optIns = React.useMemo(function () {
        if (!availableOptIns || availableOptIns.length === 0) {
            return null;
        }
        return (React.createElement(CheckboxList, { idPrefix: "opt-in__", items: availableOptIns, onChange: setSelectedOptIns, selectedItems: selectedOptIns, getItemIdentifier: function (optIn) { return optIn.value; }, renderItem: function (item) { return React.createElement("span", null, getFormattedLabel(item.titleKey, { parseHTML: true })); } }));
    }, [availableOptIns, getFormattedLabel, selectedOptIns]);
    var signUp = React.useCallback(function () {
        createAccount({
            email: userData.email,
            optIns: selectedOptIns,
            personalDetails: userData.personalDetails,
            loginRedirectUrl: loginRedirectUrl,
        });
    }, [selectedOptIns, userData.email, userData.personalDetails]);
    var handleSubmit = function (email, personalDetails) {
        setUserData({ email: email, personalDetails: personalDetails });
        setHasSignedUp(true);
    };
    React.useEffect(function () {
        if (userData.email) {
            signUp();
        }
    }, [signUp, userData]);
    if (isUninitialized$1(auth)) {
        throw new Error("Should not render SignUp page when auth is not initialized");
    }
    if (hasSignedUp) {
        var error_1 = statusFailed(auth.signupCall)
            ? new Error(getLabel('account.createAccount.signup.errors.general'))
            : undefined;
        return (React.createElement(EmailSentConfirmation, { error: error_1, email: userData.email, onResend: signUp, title: getLabel('account.signupConfirmation.title'), firstParagraph: getLabel('account.signupConfirmation.firstParagraph'), secondParagraph: getLabel('account.signupConfirmation.secondParagraph'), buttonCaption: getLabel('account.action.resendEmail') }));
    }
    return (React.createElement(SignUp, { labels: labels, loginUrl: loginUrl, optIns: optIns, onFormSubmit: handleSubmit, signUpFields: signUpFields, termsRichText: termsRichText }));
};

var mapConsents = function (selectedConsents) {
    return selectedConsents.map(function (consent) { return ({
        consentName: consent.value,
        literalText: consent.title,
        uiType: UIType.CHECKBOX,
        value: true,
    }); });
};
var useSetPassword = function () {
    var _a;
    var _b = __read(useMutation(SET_PASSWORD), 2), setPassword = _b[0], _c = _b[1], data = _c.data, loading = _c.loading, error = _c.error;
    var callback = function (_a) {
        var consents = _a.consents, rest = __rest(_a, ["consents"]);
        return setPassword({
            variables: {
                input: __assign({ consents: mapConsents(consents) }, rest),
            },
        });
    };
    return [
        callback,
        {
            customerId: (_a = data === null || data === void 0 ? void 0 : data.activateCustomerAccount) === null || _a === void 0 ? void 0 : _a.customerId,
            loading: loading,
            error: error,
        },
    ];
};

var PasswordForm = function (_a) {
    var buttonCaption = _a.buttonCaption, dataT = _a["data-t"], className = _a.className, passwordLabel = _a.passwordLabel, children = _a.children, onSubmit = _a.onSubmit;
    var _b = __read(React.useState({
        password: {
            value: '',
        },
    }), 2), state = _b[0], setState = _b[1];
    var handleSubmit = React.useCallback(function (event) {
        event.preventDefault();
        if (state.password.value) {
            onSubmit(state.password.value);
        }
    }, [onSubmit, state]);
    var setPassword = function (password) {
        var value = password.value, isValid = password.isValid;
        setState({
            password: {
                value: value,
                isValid: isValid,
            },
        });
    };
    return (React.createElement("form", { className: classnames('password-form', className), "data-t": dataT, noValidate: true, onSubmit: handleSubmit },
        React.createElement(PasswordWithStrengthIndicator, { label: passwordLabel, indicatorPosition: MediaQuery.useIsDesktop() ? 'right' : 'bottom', value: state.password.value, onChange: setPassword }),
        children,
        React.createElement(Button, { caption: buttonCaption, "data-t": "submit", type: "submit", className: "password-form__button" })));
};

var SetPassword$2 = function (_a) {
    var labels = _a.labels, consentItems = _a.consentItems, onSubmit = _a.onSubmit, hasErrors = _a.hasErrors, passwordlessErrorMessage = _a.passwordlessErrorMessage;
    return (React__default.createElement("div", { className: "create-account myaccount__section" },
        React__default.createElement(Heading, { variant: "medium", component: "h1", className: "create-account__title" }, labels.title),
        React__default.createElement("p", { className: "create-account__text" }, labels.text),
        Boolean(passwordlessErrorMessage) && (React__default.createElement(ScrollIntoView, { key: "passwordless-error" },
            React__default.createElement(Alert, { type: "error", message: passwordlessErrorMessage }))),
        hasErrors && (React__default.createElement(ScrollIntoView, { key: "default-error" },
            React__default.createElement(Alert, { type: "error", message: labels.error }))),
        React__default.createElement(PasswordForm, { "data-t": "create-account-form", passwordLabel: labels.form.password, buttonCaption: labels.form.submit, onSubmit: onSubmit }, consentItems)));
};

var SetPasswordContainer = function (_a) {
    var consentItems = _a.consentItems;
    var getLabel = useIntl().getLabel;
    var auth = useSelector(getAuth);
    var dispatch = useDispatch();
    var _b = __read(useState(''), 2), password = _b[0], setPassword = _b[1];
    var _c = __read(useState(false), 2), alreadyLoggingIn = _c[0], setAlreadyLoggingIn = _c[1];
    var _d = __read(useSetPassword(), 2), setPasswordCall = _d[0], _e = _d[1], customerId = _e.customerId, error = _e.error;
    var labels = {
        title: getLabel('account.createAccount.title'),
        text: getLabel('account.createAccount.text'),
        error: getLabel('account.createAccount.error.consentRequired'),
        form: {
            password: getLabel('fields.input.password.label'),
            submit: getLabel('account.action.createAccount'),
        },
    };
    var _f = __read(React__default.useState([]), 2), selectedConsents = _f[0], setSelectedConsents = _f[1];
    var _g = __read(React__default.useState(false), 2), hasErrors = _g[0], setHasErrors = _g[1];
    var _h = __read(React__default.useState(), 2), passwordlessErrorMessage = _h[0], setPasswordlessErrorMessage = _h[1];
    var consents = React__default.useMemo(function () {
        if (!consentItems || consentItems.length === 0) {
            return null;
        }
        return (React__default.createElement(CheckboxList, { idPrefix: "consent_", items: consentItems, renderItem: function (item) { return React__default.createElement("span", null, parseHtml(item.title)); }, getItemIdentifier: function (consent) { return consent.value; }, selectedItems: selectedConsents, onChange: setSelectedConsents }));
    }, [consentItems, selectedConsents]);
    var handleSubmit = function (password) {
        // Check if all consents were checked if there are any
        if (!consentItems.length ||
            consentItems.every(function (_a) {
                var value = _a.value;
                return selectedConsents.map(function (c) { return c.value; }).includes(value);
            })) {
            setPassword(password);
            setPasswordCall({
                password: password,
                customerId: auth.userId,
                consents: selectedConsents,
                email: auth.email,
            });
        }
        else {
            setHasErrors(true);
        }
    };
    React__default.useEffect(function () {
        if (isLoggedInPasswordless(auth) && statusFailed(auth.activateCall)) {
            var passwordStrengthErrorLabel = getPasswordStrengthErrorLabel(auth.activateCall.error);
            var message = getLabel(passwordStrengthErrorLabel || 'account.createAccount.setPassword.errors.general');
            setPasswordlessErrorMessage(message);
        }
    }, [auth, getLabel]);
    React__default.useEffect(function () {
        if (isLoggedInPasswordless(auth) && customerId && !alreadyLoggingIn) {
            // set password was successful
            setAlreadyLoggingIn(true);
            dispatch(loginWithPassword({
                email: auth.email,
                password: password,
            }));
        }
        else if (isLoggedIn$1(auth)) {
            dispatch(goto({ route: RouteKey.Profile }));
        }
        else if (isLoggedOut$1(auth)) {
            dispatch(goto({ route: RouteKey.Login }));
        }
    }, [auth, dispatch, customerId]);
    return (React__default.createElement(SetPassword$2, { labels: labels, consentItems: consents, onSubmit: handleSubmit, hasErrors: hasErrors || !!error, passwordlessErrorMessage: passwordlessErrorMessage }));
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SignUp: SignUpContainer,
  SetPassword: SetPasswordContainer
});

var renderError = function (intl, auth) {
    if (statusFailed(auth.setPasswordCall)) {
        var error = auth.setPasswordCall.error;
        var passwordStrengthErrorLabel = getPasswordStrengthErrorLabel(error);
        var errorLabel = passwordStrengthErrorLabel || 'account.resetPassword.updatePassword.errors.general';
        return (React.createElement(ScrollIntoView, null,
            React.createElement(Alert, { type: "error", message: intl.getLabel(errorLabel) })));
    }
};
var elementName$1 = 'set-password';
var SetPassword = /** @class */ (function (_super) {
    __extends(SetPassword, _super);
    function SetPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSubmit = function (password) {
            _this.props.updatePassword({ password: password });
        };
        return _this;
    }
    SetPassword.prototype.render = function () {
        var _a = this.props, intl = _a.intl, auth = _a.auth;
        if (!isLoggedInPasswordless(auth)) {
            return null;
        }
        return (React.createElement("div", { className: classnames(elementName$1, 'myaccount__section') },
            React.createElement(Heading, { variant: "medium", className: classnames(elementName$1 + "__title") }, intl.getLabel('account.resetPassword.confirmation.title')),
            React.createElement("p", { className: elementName$1 + "__text" }, intl.getLabel('account.resetPassword.setPassword.text')),
            renderError(intl, auth),
            React.createElement(PasswordForm, { "data-t": "set-password-form", passwordLabel: intl.getLabel('fields.input.password.label'), buttonCaption: intl.getLabel('account.action.setPassword'), onSubmit: this.onSubmit })));
    };
    return SetPassword;
}(React.Component));
var mapDispatchToProps$2 = {
    updatePassword: updatePassword,
};
var mapStateToProps$1 = function (state) { return ({
    auth: getAuth(state),
}); };
var SetPassword$1 = connect(mapStateToProps$1, mapDispatchToProps$2)(withIntl(SetPassword));

var elementName = 'submit-email-address';
var SubmitEmailAddress = /** @class */ (function (_super) {
    __extends(SubmitEmailAddress, _super);
    function SubmitEmailAddress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            email: '',
            isEmailSubmitted: false,
        };
        _this.onHandleResend = function () {
            _this.props.resetPassword({ email: _this.state.email });
        };
        _this.onSubmit = function (email) {
            _this.setState({ email: email, isEmailSubmitted: true }, function () {
                _this.props.resetPassword({ email: email });
            });
        };
        return _this;
    }
    SubmitEmailAddress.prototype.render = function () {
        var _a = this.props, intl = _a.intl, auth = _a.auth;
        var _b = this.state, email = _b.email, isEmailSubmitted = _b.isEmailSubmitted;
        if (isUninitialized$1(auth)) {
            return null;
        }
        var error = statusFailed(auth.resetPasswordCall)
            ? new Error(intl.getLabel('account.resetPassword.updatePassword.errors.general'))
            : undefined;
        // If email is submitted and call is finished we can show confirmation screen
        if (isEmailSubmitted) {
            return (React.createElement(EmailSentConfirmation, { onResend: this.onHandleResend, email: email, title: intl.getLabel('account.resetPassword.confirmation.title'), firstParagraph: intl.getLabel('account.resetPassword.confirmation.firstParagraph'), secondParagraph: intl.getLabel('account.resetPassword.confirmation.secondParagraph'), buttonCaption: intl.getLabel('account.action.resendEmail'), error: error }));
        }
        return (React.createElement("div", { className: classnames(elementName, 'myaccount__section') },
            React.createElement(Heading, { variant: "medium", component: "h1", className: elementName + "__title" }, intl.getLabel('account.resetPassword.submitEmailAddress.title')),
            React.createElement("p", { className: elementName + "__text" }, intl.getLabel('account.resetPassword.submitEmailAddress.text')),
            React.createElement(EmailForm, { buttonLabel: intl.getLabel('account.action.resetPassword'), "data-t": "reset-password-form", emailErrorLabel: intl.getLabel('account.error.emailInvalid'), emailLabel: intl.getLabel('fields.input.email.label'), onSubmit: this.onSubmit })));
    };
    return SubmitEmailAddress;
}(React.Component));
var mapStateToProps = function (state) { return ({
    auth: getAuth(state),
}); };
var mapDispatchToProps$1 = {
    resetPassword: resetPassword,
};
var SubmitEmailAddress$1 = connect(mapStateToProps, mapDispatchToProps$1)(withIntl(SubmitEmailAddress));

var VALIDATE_ACCOUNT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ValidateCustomerAccount($input: ValidateAccountInput!) {\n    validateCustomerAccount(input: $input) {\n      ... on AccountValidatedSuccessfully {\n        customerId\n      }\n      ... on AccountValidationMaxRetriesError {\n        retries\n      }\n    }\n  }\n"], ["\n  mutation ValidateCustomerAccount($input: ValidateAccountInput!) {\n    validateCustomerAccount(input: $input) {\n      ... on AccountValidatedSuccessfully {\n        customerId\n      }\n      ... on AccountValidationMaxRetriesError {\n        retries\n      }\n    }\n  }\n"])));
var templateObject_1;

var useValidateAccount = function () {
    var _a = __read(useState(false), 2), isWrongDOB = _a[0], setIsWrongDOB = _a[1];
    var onError = useCallback(function (_a) {
        _a.graphQLErrors; _a.networkError;
        setIsWrongDOB(true);
        return null;
    }, [setIsWrongDOB]);
    var _b = __read(useMutation(VALIDATE_ACCOUNT, { onError: onError }), 2), validateAccount = _b[0], _c = _b[1], data = _c.data, loading = _c.loading, error = _c.error;
    var callback = function (input) {
        setIsWrongDOB(false);
        validateAccount({
            variables: {
                input: input,
            },
        }).catch(function (e) { return setIsWrongDOB(true); });
    };
    if ((data === null || data === void 0 ? void 0 : data.validateCustomerAccount.__typename) === 'AccountValidatedSuccessfully') {
        return [
            callback,
            {
                customerId: data === null || data === void 0 ? void 0 : data.validateCustomerAccount.customerId,
                loading: loading,
                error: error,
                isWrongDOB: isWrongDOB,
            },
        ];
    }
    else if ((data === null || data === void 0 ? void 0 : data.validateCustomerAccount.__typename) === 'AccountValidationMaxRetriesError') {
        return [
            callback,
            {
                retries: data === null || data === void 0 ? void 0 : data.validateCustomerAccount.retries,
                loading: loading,
                error: error,
                isWrongDOB: isWrongDOB,
            },
        ];
    }
    return [callback, { loading: loading, error: error, isWrongDOB: isWrongDOB }];
};

var formatDate = function (date) {
    var _a = __read(date.split('-'), 3), year = _a[0], month = _a[1], day = _a[2];
    return year + "-" + month.padStart(2, '0') + "-" + day.padStart(2, '0');
};
var Verify = (function () {
    var elementName = 'verify';
    var getLabel = useIntl().getLabel;
    var auth = useSelector(getAuth);
    var dispatch = useDispatch();
    var _a = __read(useState(Util.fieldsToFormState({ dob: '' })), 2), formState = _a[0], setFormState = _a[1];
    var _b = __read(useValidateAccount(), 2), validateAccount = _b[0], _c = _b[1], error = _c.error, loading = _c.loading, customerId = _c.customerId, retries = _c.retries, isWrongDOB = _c.isWrongDOB;
    var handleSubmit = useCallback(function (formState) {
        var dob = Util.getValuesFromState(formState.formState).dob;
        if (dob) {
            try {
                validateAccount({
                    customerId: auth.userId,
                    validationValue: formatDate(dob),
                });
            }
            catch (e) {
                console.warn(e);
                console.warn(error);
            }
        }
    }, [validateAccount, formState.formState]);
    var handleChange = function (newState) { return setFormState(newState.formState); };
    useEffect(function () {
        if (customerId)
            dispatch(goto({ route: RouteKey.CreateAccount }));
    }, [customerId, dispatch]);
    if (isUninitialized$1(auth)) {
        throw new Error('Should not render SignUp page when auth is not initialized');
    }
    return (React__default.createElement("div", { className: classnames(elementName, 'myaccount__section') },
        React__default.createElement(Heading, { variant: "medium", className: classnames(elementName + "__title") }, getLabel('account.resetPassword.validation.title')),
        React__default.createElement(Text, { className: elementName + "__text" }, getLabel('account.resetPassword.validation.text')),
        isWrongDOB && (React__default.createElement(Alert, { type: "error", icon: "alert-circle", message: getLabel('account.resetPassword.validation.error.wrongDateOfBirth') })),
        retries && (React__default.createElement(Alert, { type: "error", icon: "alert-circle", message: getLabel('account.resetPassword.validation.error.tooManyAttempts') })),
        React__default.createElement(Form, { name: "verify-form", "data-t": "verify-form", className: classnames('password-form'), initialFormState: formState, onChange: handleChange, onSubmit: handleSubmit },
            React__default.createElement(DateOfBirthSelect, { name: "dob", label: getLabel('account.resetPassword.validation.dateOfBirth'), dayPlaceholder: getLabel('checkout.contact.dateofbirth.day.placeholder'), monthPlaceholder: getLabel('checkout.contact.dateofbirth.month.placeholder'), yearPlaceholder: getLabel('checkout.contact.dateofbirth.year.placeholder'), errorMessage: getLabel('account.resetPassword.validation.error.noDateOfBirth'), validations: [Util.validations.isDateOfBirth, Util.validations.isRequired], required: true }),
            React__default.createElement(Button, { caption: getLabel('account.action.confirm'), "data-t": "submit", type: "submit", className: "password-form__button", disabled: retries !== undefined, isLoading: loading }))));
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SetPassword: SetPassword$1,
  SubmitEmailAddress: SubmitEmailAddress$1,
  Verify: Verify
});

function getActivePath() {
    var url = new URL(window.location.href);
    return url.pathname;
}
var hrefToUrl = function (href) { return new URL("" + window.location.origin + href); };
var getMyAccountMenuItems = function (logout, routes, intl, isUserLoggedIn, isAddressBookEnabled, isAabEnabled, isSubscriptionsV2Enabled, onNavigate) {
    var _a, _b, _c, _d, _e, _f;
    var activePath = getActivePath();
    var navigate = function (href) { return function (e) {
        if (isModifiedClickEvent(e)) {
            return;
        }
        e.preventDefault();
        var url = hrefToUrl(href);
        onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(url);
    }; };
    var logoutItem = {
        label: intl.getLabel('account.menu.logOut'),
        parameters: {
            icon: 'logout',
            action: logout,
            testId: 'logout',
        },
        childMenuItems: [],
        link: { href: '', type: 'external' },
    };
    var loginItem = {
        label: intl.getLabel('account.action.login'),
        childMenuItems: [],
        parameters: {
            testId: 'login',
        },
        link: { href: routes.login, type: 'external' },
    };
    function getProfileChildMenuItems() {
        var _a, _b;
        var items = [];
        if (isAddressBookEnabled) {
            items.push({
                label: intl.getLabel('account.menu.addresses'),
                link: {
                    href: (_a = routes.addressBook) !== null && _a !== void 0 ? _a : '',
                    onClick: routes.addressBook && onNavigate ? navigate(routes.addressBook) : undefined,
                    type: 'external',
                    active: [routes.addressBook].includes(activePath),
                },
                parameters: {
                    testId: 'addressBook',
                },
            });
        }
        items.push({
            label: intl.getLabel('account.menu.changePassword'),
            link: {
                href: (_b = routes.changePassword) !== null && _b !== void 0 ? _b : '',
                onClick: routes.changePassword && onNavigate ? navigate(routes.changePassword) : undefined,
                type: 'external',
                active: [routes.changePassword].includes(activePath),
            },
            parameters: {
                testId: 'changePassword',
            },
        });
        return items;
    }
    var userHasParsedDataFromLS = getParsedDataFromLS();
    var lastItem = logoutItem;
    if (!isUserLoggedIn && !userHasParsedDataFromLS) {
        lastItem = loginItem;
    }
    var items = [
        {
            label: intl.getLabel('account.menu.accountDetails'),
            parameters: {
                icon: 'user',
                testId: 'profile',
            },
            link: {
                href: (_a = routes.profile) !== null && _a !== void 0 ? _a : '',
                onClick: routes.profile && onNavigate ? navigate(routes.profile) : undefined,
                type: 'external',
                active: [routes.addressBook, routes.changePassword, routes.profile].includes(activePath),
            },
            childMenuItems: getProfileChildMenuItems(),
        },
        {
            label: intl.getLabel('account.menu.appointments'),
            parameters: {
                icon: 'calendar',
                testId: 'appointments',
            },
            link: {
                href: (isAabEnabled && routes.appointments) || '',
                onClick: routes.appointments && onNavigate ? navigate(routes.appointments) : undefined,
                type: 'external',
                active: routes.appointments === activePath,
            },
        },
        {
            label: intl.getLabel('account.menu.prescriptions'),
            parameters: {
                icon: 'frame',
                testId: 'prescriptions',
            },
            link: {
                href: (_b = routes.prescriptions) !== null && _b !== void 0 ? _b : '',
                onClick: routes.prescriptions && onNavigate ? navigate(routes.prescriptions) : undefined,
                type: 'external',
                active: routes.prescriptions === activePath,
            },
        },
        {
            label: intl.getLabel('account.menu.orders'),
            parameters: {
                icon: 'orders',
                testId: 'orders',
            },
            link: {
                href: (_c = routes.orders) !== null && _c !== void 0 ? _c : '',
                onClick: routes.orders && onNavigate ? navigate(routes.orders) : undefined,
                type: 'external',
                active: routes.orders === activePath,
            },
        },
        {
            label: intl.getLabel('account.menu.subscriptions'),
            parameters: {
                icon: 'shipment-next',
                testId: 'subscriptions',
            },
            link: {
                href: (_d = routes.subscriptions) !== null && _d !== void 0 ? _d : '',
                onClick: routes.subscriptions && onNavigate ? navigate(routes.subscriptions) : undefined,
                type: 'external',
                active: Boolean(routes.subscriptions &&
                    !(routes.subscriptionsv2 && activePath.startsWith(routes.subscriptionsv2)) &&
                    activePath.startsWith(routes.subscriptions)),
            },
        },
        {
            label: "" + intl.getLabel('account.menu.subscriptions-v2'),
            parameters: {
                icon: 'shipment-next',
                testId: 'subscriptionsv2',
            },
            link: {
                href: isSubscriptionsV2Enabled ? (_e = routes.subscriptionsv2) !== null && _e !== void 0 ? _e : '' : '',
                onClick: routes.subscriptionsv2 && isSubscriptionsV2Enabled && onNavigate
                    ? navigate(routes.subscriptionsv2)
                    : undefined,
                type: 'external',
                active: routes.subscriptionsv2 ? activePath.startsWith(routes.subscriptionsv2) : false,
            },
        },
        {
            label: intl.getLabel('account.menu.privacy'),
            parameters: {
                icon: 'lock',
                testId: 'privacy',
            },
            link: {
                href: (_f = routes.privacy) !== null && _f !== void 0 ? _f : '',
                onClick: routes.privacy && onNavigate ? navigate(routes.privacy) : undefined,
                type: 'external',
                active: routes.privacy === activePath,
            },
        },
        lastItem,
    ];
    var hasLink = function (item) { var _a; return ((_a = item.link) === null || _a === void 0 ? void 0 : _a.href) && item.link.href !== ''; };
    var hasAction = function (item) { var _a; return (_a = item.parameters) === null || _a === void 0 ? void 0 : _a.action; };
    return items.filter(function (item) { return hasLink(item) || hasAction(item); });
};

var Loader = function () {
    var getLabel = useIntl().getLabel;
    return (React.createElement(SkeletonLoader, { className: "myaccount-menu-loader", "data-t": "myaccount-menu-loader" },
        React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "16", "aria-label": getLabel('common.loadingText') },
            React.createElement("rect", { width: "100%", height: "16", rx: "5", fill: "currentColor" }))));
};

var PersonalizedGreeting = function (_a) {
    var personalDetails = _a.personalDetails, _b = _a.greetingFormatter, greetingFormatter = _b === void 0 ? function () { return undefined; } : _b;
    var _c = useIntl(), getFormattedLabel = _c.getFormattedLabel, getLabel = _c.getLabel;
    var formattedMessage = greetingFormatter({ data: personalDetails, getLabel: getFormattedLabel });
    var defaultMessage = !!personalDetails
        ? getFormattedLabel('account.menu.greeting.withPersonalDetails', {
            labelData: personalDetails,
        })
        : getLabel('account.menu.greeting.withoutPersonalDetails');
    return (React.createElement(React.Fragment, null,
        React.createElement(Icon, { name: "user-checkmark" }),
        React.createElement("span", { className: "myaccount-menu-button__label", "data-t": "personalized-greeting" }, formattedMessage !== null && formattedMessage !== void 0 ? formattedMessage : defaultMessage)));
};

var MyAccountMenu = function (_a) {
    var _b = _a.menuItems, menuItems = _b === void 0 ? [] : _b, greetingFormatter = _a.greetingFormatter, viewState = _a.viewState, personalDetails = _a.personalDetails, className = _a.className;
    var getLabel = useIntl().getLabel;
    return (React.createElement(Flyout, { "data-t": "myaccount-menu", id: "myaccount-menu", className: classnames('myaccount-menu', className) },
        React.createElement(Flyout.Trigger, { "data-t": "my-account-menu-button", className: classnames('header-menu__icon myaccount-menu-button', className, 'myaccount-menu-button--link'), title: getLabel('account.menu.myAccount'), "aria-controls": "myaccount-menu" },
            viewState === 'unknown-user' && (React.createElement(React.Fragment, null,
                React.createElement(Icon, { name: "user" }),
                React.createElement("span", { "data-t": "logged-out-greeting", className: "myaccount-menu-button__label" }, getLabel('account.menu.greeting.loggedOut')))),
            viewState === 'known-user' && (React.createElement(PersonalizedGreeting, { personalDetails: personalDetails, greetingFormatter: greetingFormatter })),
            viewState === 'loading' && React.createElement(Loader, null)),
        React.createElement(Flyout.Menu, null, menuItems.map(function (item) {
            var _a, _b;
            return (React.createElement(Flyout.MenuItem, { key: item.label, link: (_a = item.link) === null || _a === void 0 ? void 0 : _a.href, action: (_b = item.parameters) === null || _b === void 0 ? void 0 : _b.action }, item.label));
        }))));
};

var MyAccountMenuContainer = function (props) {
    var auth = useSelector(getAuth);
    var userData = useSelector(getUserData) || uninitState();
    var _a = __read(React.useState('loading'), 2), viewState = _a[0], setViewState = _a[1];
    var _b = __read(React.useState(getParsedDataFromLS), 2), personalDetails = _b[0], setPersonalDetails = _b[1];
    React.useEffect(function () {
        var isAuthLoading = getLoggedInState(auth) === 'loading';
        if (isAuthLoading || statusLoading(userData)) {
            setViewState('loading');
            // If the user is logged in or if there are personal details in local storage.
        }
        else if (isLoggedIn$1(auth) || !!personalDetails) {
            setViewState('known-user');
            if (statusSuccess(userData)) {
                setPersonalDetails(userData.result.personalDetails);
                //todo: move this to a saga
                writeUserDataToLS(userData.result.personalDetails);
            }
        }
        else {
            setViewState('unknown-user');
        }
    }, [auth, userData]);
    return React.createElement(MyAccountMenu, __assign({}, props, { viewState: viewState, personalDetails: personalDetails }));
};

var AuthContext = React.createContext({});
var AuthContextConsumer = function (_a) {
    var children = _a.children;
    return (React.createElement(AuthContext.Consumer, null, function (context) {
        if (!context || Object.keys(context).length === 0) {
            return React.createElement("p", { className: "my-account--no-context" }, "Auth Provider missing in application.");
        }
        if (!context.enabled) {
            // TODO: instead redirect?
            return React.createElement("p", { className: "my-account--not-enabled" }, "Auth not enabled in application.");
        }
        return React.createElement(React.Fragment, null, children);
    }));
};

var AuthProvider = /** @class */ (function (_super) {
    __extends(AuthProvider, _super);
    function AuthProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthProvider.prototype.componentDidMount = function () {
        if (this.props.enabled) {
            this.props.init(this.props.settings);
        }
    };
    AuthProvider.prototype.render = function () {
        var _a = this.props, children = _a.children, enabled = _a.enabled;
        var context = { enabled: enabled };
        return React.createElement(AuthContext.Provider, { value: context }, children);
    };
    return AuthProvider;
}(React.PureComponent));
var mapDispatchToProps = {
    init: init$1,
};
var AuthProvider$1 = connect(null, mapDispatchToProps)(AuthProvider);

var UNKNOWN = 'UNKNOWN';
var useAccount = function () {
    var dispatch = useDispatch();
    var auth = useSelector(getAuth);
    var currentlyInitialized = isInitialized$1(auth);
    useEffect(function () {
        if (currentlyInitialized) {
            dispatch(recoverSession$1());
        }
    }, [currentlyInitialized]);
    if (currentlyInitialized) {
        return UNKNOWN;
    }
    // "passwordless" logins will return false here
    if (isLoggedIn$1(auth)) {
        return AuthState.LoggedIn;
    }
    if (isLoggedInPasswordless(auth) || isParseHashFailed(auth) || isLoggedOut$1(auth)) {
        return AuthState.LoggedOut;
    }
    return UNKNOWN;
};

var initialState$2 = {
    optInsOnServer: uninitState(),
    changedOptIns: {},
    updateOptInsCall: idleState(),
};
function optInsReducer(state, action) {
    if (state === void 0) { state = initialState$2; }
    switch (action.type) {
        case FETCH_OPT_INS:
            return __assign(__assign({}, state), { optInsOnServer: loadingState() });
        case FETCH_OPT_INS_SUCCESS:
            return __assign(__assign({}, state), { optInsOnServer: successState(action.payload) });
        case FETCH_OPT_INS_FAILED:
            return __assign(__assign({}, state), { optInsOnServer: failedState(action.error) });
        case TOGGLE_OPT_INS:
            return __assign(__assign({}, state), { changedOptIns: __assign(__assign({}, state.changedOptIns), action.payload) });
        case UPDATE_OPT_INS:
            return __assign(__assign({}, state), { updateOptInsCall: loadingState() });
        case UPDATE_OPT_INS_SUCCESS:
            return __assign(__assign({}, state), { updateOptInsCall: idleState() });
        case UPDATE_OPT_INS_FAILED:
            return __assign(__assign({}, state), { updateOptInsCall: failedState(action.error) });
    }
    return state;
}

var initialState$1 = {
    userData: uninitState(),
    updateCalls: {
        personalDetails: idleState(),
        billingAddress: idleState(),
        preferredStore: idleState(),
    },
};
function userDataReducer(state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = initialState$1; }
    switch (action.type) {
        case FETCH_USER_DATA:
            return __assign(__assign({}, state), { userData: loadingState() });
        case FETCH_USER_DATA_FAILED:
            return __assign(__assign({}, state), { userData: failedState(action.error) });
        case FETCH_USER_DATA_SUCCESS:
            return __assign(__assign({}, state), { userData: successState(action.payload) });
        case UPDATE_USER_DATA:
            return __assign(__assign({}, state), { updateCalls: __assign(__assign({}, state.updateCalls), (_a = {}, _a[action.payload.formName] = loadingState(), _a)) });
        case UPDATE_USER_DATA_SUCCESS:
            return __assign(__assign({}, state), { userData: successState(action.payload.server), updateCalls: __assign(__assign({}, state.updateCalls), (_b = {}, _b[action.payload.formName] = idleState(), _b)) });
        case UPDATE_USER_DATA_FAILED:
            return __assign(__assign({}, state), { updateCalls: __assign(__assign({}, state.updateCalls), (_c = {}, _c[action.payload.formName] = failedState(action.payload.error), _c)) });
    }
    return state;
}

var initialState = {
    state: AuthState.Uninitialized,
};
function fail(union) {
    throw new Error("Should also account for " + union);
}
// this is to set the global state of auth package (store)
function reducer (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case INIT:
            var _a = action.payload, apiUrl = _a.apiUrl, domain = _a.domain, clientId = _a.clientId, customDomain = _a.customDomain, routes = _a.routes, basePath = _a.basePath, _b = _a.optIns, optIns = _b === void 0 ? [] : _b, _c = _a.userSettings, userSettings = _c === void 0 ? {
                optInsState: initialState$2,
                userDataState: initialState$1,
            } : _c, checkoutRoute = _a.checkoutRoute, _d = _a.enableLegacyOrderHistory, enableLegacyOrderHistory = _d === void 0 ? false : _d, _e = _a.putPrescriptionTokensOnCart, putPrescriptionTokensOnCart = _e === void 0 ? false : _e, _f = _a.isAabEnabled, isAabEnabled = _f === void 0 ? false : _f, _g = _a.disableAddressEditing, disableAddressEditing = _g === void 0 ? false : _g;
            return {
                state: AuthState.Initialized,
                apiUrl: apiUrl,
                domain: domain,
                clientId: clientId,
                customDomain: customDomain,
                routing: {
                    basePath: basePath,
                    routes: routes,
                    checkoutRoute: checkoutRoute,
                },
                optIns: optIns,
                userSettings: userSettings,
                loginCall: idleState(),
                signupCall: idleState(),
                resetPasswordCall: idleState(),
                enableLegacyOrderHistory: enableLegacyOrderHistory,
                putPrescriptionTokensOnCart: putPrescriptionTokensOnCart,
                isAabEnabled: isAabEnabled,
                disableAddressEditing: disableAddressEditing,
            };
        case SET_PASSWORD$1:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can only dispatch " + SET_PASSWORD$1 + " when user is logged in with passwordless flow");
            }
            return __assign(__assign({}, state), { activateCall: loadingState() });
        case SET_PASSWORD_FAILED:
            var error = action.error;
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can only dispatch " + SET_PASSWORD_FAILED + " when user is logged in with passwordless flow");
            }
            return __assign(__assign({}, state), { activateCall: failedState(error) });
        case SET_PASSWORD_SUCCESS:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can only dispatch " + SET_PASSWORD_SUCCESS + " when user is logged in with passwordless flow");
            }
            return __assign(__assign({}, state), { activateCall: idleState(), hasActivatedAccount: true });
        case SIGNUP:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { signupCall: loadingState() });
        case SIGNUP_SUCCESS:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { signupCall: idleState() });
        case SIGNUP_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { signupCall: failedState(action.error) });
        case RESET_PASSWORD:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { resetPasswordCall: loadingState() });
        case RESET_PASSWORD_SUCCESS:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { resetPasswordCall: idleState() });
        case RESET_PASSWORD_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { resetPasswordCall: failedState(action.error) });
        case UPDATE_PASSWORD:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { setPasswordCall: loadingState() });
        case UPDATE_PASSWORD_FAILED:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { setPasswordCall: failedState(action.error) });
        case UPDATE_PASSWORD_SUCCESS:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { setPasswordCall: idleState() });
        case CHANGE_PASSWORD:
            if (!isLoggedIn$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { changePasswordCall: loadingState() });
        case CHANGE_PASSWORD_FAILED:
            if (!isLoggedIn$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { changePasswordCall: failedState(action.error) });
        case CHANGE_PASSWORD_SUCCESS:
            if (!isLoggedIn$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            /**
             * We don't want to set this call from loading state back to idle state because we want to keep the submit button
             * in loading state. The finished call will trigger a redirect which will refresh the page and also reset this
             * part of the Redux store, since it's not persisted.
             */
            return state;
        case LOGIN:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions auth is initialized");
            }
            return __assign(__assign({}, state), { loginCall: loadingState() });
        case LOGIN_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { loginCall: failedState(action.error) });
        case PARSE_HASH_SUCCEEDED:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            switch (action.payload.type) {
                default:
                    return fail(action.payload);
                case 'regular':
                    return __assign(__assign({}, state), { state: AuthState.LoggedIn, userId: action.payload.id, email: action.payload.email, type: 'regular', loginCall: idleState(), changePasswordCall: idleState() });
                case 'passwordless':
                    return __assign(__assign({}, state), { state: AuthState.LoggedIn, userId: action.payload.id, email: action.payload.email, type: 'passwordless', loginCall: idleState(), hasActivatedAccount: action.payload.hasActivatedAccount, activateCall: idleState(), setPasswordCall: idleState() });
            }
        case PARSE_HASH_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { state: AuthState.ParseHashFailed, error: action.payload.error, email: action.payload.email });
        case RECOVER_SESSION_FAILED:
            if (isUninitialized$1(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            if (isLoggedIn$1(state) || isLoggedInPasswordless(state)) {
                // We don't care session recovery has failed if we're logged in anyway
                return state;
            }
            return __assign(__assign({}, state), { state: AuthState.LoggedOut, error: action.error });
    }
    if (isLoggedIn$1(state)) {
        return __assign(__assign({}, state), { userSettings: {
                optInsState: optInsReducer(state.userSettings.optInsState, action),
                userDataState: userDataReducer(state.userSettings.userDataState, action),
            } });
    }
    return state;
}

/**
 * This module wraps the official Auth0 auth0-js client library.
 *
 * Basically it's just a bunch of calls converted to promises with a token renewal
 * channel that publishes a renewal event when the token is about to expire.
 *
 * API Documentation can be found here: https://auth0.github.io/auth0.js
 * The source is here: https://github.com/auth0/auth0.js
 *
 */
var webAuth;
var authOptions;
var dbConnection = 'Username-Password-Authentication';
/**
 * Some assertions that provide a clear error message when you've forgot to call init before other operations
 */
var assertInit = {
    isInitialized: function () {
        if (!webAuth) {
            return new Error("WebAuth hasn't been initialized. Make sure you call `init` before any other operations.");
        }
    },
    throwIfUninitialized: function () {
        var error = assertInit.isInitialized();
        if (error !== undefined) {
            throw error;
        }
    },
    rejectIfUninitialized: function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            var error;
            return __generator(this, function (_a) {
                error = assertInit.isInitialized();
                if (error) {
                    return [2 /*return*/, Promise.reject(error)];
                }
                return [2 /*return*/, new Promise(callback)];
            });
        });
    },
};
/**
 * If the token is about to expire a RenewalRequired action will be published on this channel.
 * Refreshing the token is up to the consumer. A call to `checkSession` will get a fresh token.
 */
var renewalRequired = channel(buffers.none());
var renewalTimeoutToken;
function scheduleRenewal(expiresIn) {
    window.clearTimeout(renewalTimeoutToken);
    renewalTimeoutToken = window.setTimeout(function () {
        renewalRequired.put({
            type: '@@auth/RENEWAL_REQUIRED',
        });
    }, expiresIn * 1000 - 5000); // Request renewal 5s before it expires
}
/**
 * Creates a new WebAuth instance. Should be called at least once
 */
function init(options) {
    authOptions = options;
    webAuth = new WebAuth(authOptions);
}
/**
 * Wraps WebAuth.checkSession, see: https://auth0.github.io/auth0.js/global.html#checkSession
 *
 * It can be used to keep a session alive or continue on open one (say, after a page refresh)
 * Will also schedule a renewal event, see the `renewalRequired` channel at the top of the module
 */
function checkSession(options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, assertInit.rejectIfUninitialized(function (resolve, reject) {
                    webAuth.checkSession(options, function (err, authResult) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        if (!authResult) {
                            reject(new Error("Failed to checkSession, authResult was null"));
                            return;
                        }
                        if (authResult.expiresIn) {
                            scheduleRenewal(authResult.expiresIn);
                        }
                        resolve(authResult);
                    });
                })];
        });
    });
}
/**
 * Wraps webAuth.crossOriginAuthentication, see: https://auth0.github.io/auth0.js/global.html#login
 * (search for cross-origin-authentication to find the correct type of login)
 *
 * Logs in the user with username and password using the cross origin authentication flow
 */
function crossOriginAuthentication(email, password, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, assertInit.rejectIfUninitialized(function (resolve, reject) {
                    webAuth.login(__assign(__assign({}, options), { username: email, realm: dbConnection, password: password, 
                        // @ts-ignore (types of auth0-js package are not complete
                        responseType: 'token id_token', state: JSON.stringify({ email: email }) }), function (err, result) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        resolve(result);
                    });
                })];
        });
    });
}
/**
 * Wraps WebAuth.parseHash, see: https://auth0.github.io/auth0.js/global.html#parseHash
 *
 * This function should be called on the returnUri (ie, the page that auth0 sends the user back to)
 * Will also schedule a renewal event, see the `renewalRequired` channel at the top of the module
 */
function parseHash$1(options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, assertInit.rejectIfUninitialized(function (resolve, reject) {
                    var callback = function (err, authResult) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        if (!authResult) {
                            reject(new Error("Failed to parseHash, authResult was '" + authResult + "'"));
                            return;
                        }
                        if (authResult.expiresIn) {
                            scheduleRenewal(authResult.expiresIn);
                        }
                        resolve(authResult);
                    };
                    if (options) {
                        webAuth.parseHash(options, callback);
                    }
                    else {
                        webAuth.parseHash(callback);
                    }
                })];
        });
    });
}
/**
 * Wraps WebAuth.client.userInfo, see: https://auth0.github.io/auth0.js/global.html#userInfo
 */
function userInfo(accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!accessToken) {
                throw new Error('accessToken needs to be non-empty');
            }
            return [2 /*return*/, assertInit.rejectIfUninitialized(function (resolve, reject) {
                    webAuth.client.userInfo(accessToken, function (err, userResult) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        resolve(userResult);
                    });
                })];
        });
    });
}
/**
 * Wraps WebAuth.logout, see: https://auth0.github.io/auth0.js/global.html#logout
 */
function logout(returnTo) {
    assertInit.throwIfUninitialized();
    window.clearTimeout(renewalTimeoutToken);
    // Redirects out
    webAuth.logout({
        returnTo: returnTo,
    });
}

var audience = 'fake_https://api.local:3080/';
var tokenCache = {};
var createTokenKey = function (audience, scopes) { return audience + "::" + scopes; };
var cacheToken = function (accessToken) {
    var token = jwtDecode(accessToken);
    var tokenKey = createTokenKey(Array.isArray(token.aud) ? token.aud.join(' ') : token.aud, token.scope);
    var timeoutToken = ejectTokenFromCache(tokenKey, token.exp);
    tokenCache[tokenKey] = {
        token: accessToken,
        clearTimeoutToken: timeoutToken,
    };
};
var ejectTokenFromCache = function (tokenKey, expiresIn) {
    return window.setTimeout(function () {
        if (tokenKey in tokenCache) {
            delete tokenCache[tokenKey];
        }
    }, expiresIn * 1000 - 5000);
};
var getToken = function () {
    var scopes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        scopes[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var scopeString, tokenKey, authResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    scopeString = scopes.join(' ');
                    tokenKey = createTokenKey(audience, scopeString);
                    if (tokenKey in tokenCache) {
                        return [2 /*return*/, tokenCache[tokenKey].token];
                    }
                    return [4 /*yield*/, checkSession({
                            audience: audience,
                            scope: scopeString,
                            responseType: 'token',
                        })];
                case 1:
                    authResult = _a.sent();
                    if (!authResult.accessToken) {
                        throw new Error("Did not receive accessToken from Auth0");
                    }
                    if (!authResult.expiresIn) {
                        throw new Error("Did not receive accessToken expiry, received '" + authResult.expiresIn + "'");
                    }
                    cacheToken(authResult.accessToken);
                    return [2 /*return*/, authResult.accessToken];
            }
        });
    });
};

var getCustomerUri = function (apiUrl, customerId) {
    return apiUrl + "/customers/customer/" + encodeURIComponent(customerId);
};
var getAccountUri = function (apiUrl) { return apiUrl + "/customers/account"; };
var unwrapResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!!response.ok) return [3 /*break*/, 5];
                result = '';
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, response.text()];
            case 2:
                result = _b.sent();
                return [3 /*break*/, 4];
            case 3:
                _b.sent();
                return [3 /*break*/, 4];
            case 4: throw new Error("Got non OK response from server: " + response.status + " " + response.statusText + ": " + result);
            case 5: return [2 /*return*/, response.json()];
        }
    });
}); };
var baseOptions = {
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-cache',
};
var optIns = {
    fetch: function (apiUrl, customerId) {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getToken()];
                    case 1:
                        accessToken = _b.sent();
                        _a = unwrapResponse;
                        return [4 /*yield*/, fetch(getCustomerUri(apiUrl, customerId) + "/optins", __assign(__assign({}, baseOptions), { method: 'GET', headers: new Headers({
                                    Authorization: "Bearer " + accessToken,
                                    'Content-Type': 'application/json',
                                }) }))];
                    case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    },
    update: function (apiUrl, customerId, optinUpdates) {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getToken()];
                    case 1:
                        accessToken = _b.sent();
                        _a = unwrapResponse;
                        return [4 /*yield*/, fetch(getCustomerUri(apiUrl, customerId) + "/optins", __assign(__assign({}, baseOptions), { method: 'POST', headers: new Headers({
                                    Authorization: "Bearer " + accessToken,
                                    'Content-Type': 'application/json',
                                }), body: JSON.stringify({
                                    optinUpdates: optinUpdates,
                                }) }))];
                    case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    },
};
var account = {
    signup: function (apiUrl, loginRedirectUrl, emailAddress, additionalAccountData, reason) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, personalDetails, _b, optins, optInsUpdate, additionalData, locale, stateParams, body, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = additionalAccountData.personalDetails, personalDetails = _a === void 0 ? {} : _a, _b = additionalAccountData.optins, optins = _b === void 0 ? {} : _b;
                        optInsUpdate = Object.keys(optins).length > 0 ? optins : undefined;
                        additionalData = { personalDetails: personalDetails, optins: optInsUpdate };
                        locale = LocaleUtils.getLocaleFromCookie();
                        stateParams = { targetAction: 'signUp' };
                        body = __assign({ loginRedirectUrl: loginRedirectUrl, emailAddress: emailAddress, state: JSON.stringify(stateParams), reason: reason }, additionalData);
                        body = locale ? __assign(__assign({}, body), { locale: locale }) : body;
                        _c = unwrapResponse;
                        return [4 /*yield*/, fetch(getAccountUri(apiUrl) + "/create", __assign(__assign({}, baseOptions), { method: 'POST', headers: new Headers({
                                    'Content-Type': 'application/json',
                                    Accept: 'application/json',
                                }), body: JSON.stringify(body) }))];
                    case 1: return [2 /*return*/, _c.apply(void 0, [_d.sent()])];
                }
            });
        });
    },
    activate: function (apiUrl, accessToken, accountId, emailAddress, password, consents) {
        return __awaiter(this, void 0, void 0, function () {
            var locale, body, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        locale = LocaleUtils.getLocaleFromCookie();
                        body = {
                            emailAddress: emailAddress,
                            password: password,
                            consents: consents,
                        };
                        body = locale ? __assign(__assign({}, body), { locale: locale }) : body;
                        _a = unwrapResponse;
                        return [4 /*yield*/, fetch(getAccountUri(apiUrl) + "/activate/" + encodeURIComponent(accountId), __assign(__assign({}, baseOptions), { method: 'POST', headers: new Headers({
                                    Authorization: "Bearer " + accessToken,
                                    'Content-Type': 'application/json',
                                }), body: JSON.stringify(body) }))];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    },
    changePassword: function (apiUrl, accessToken, accountId, password) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = unwrapResponse;
                        return [4 /*yield*/, fetch(getAccountUri(apiUrl) + "/changepassword/" + encodeURIComponent(accountId), __assign(__assign({}, baseOptions), { method: 'POST', headers: new Headers({
                                    Authorization: "Bearer " + accessToken,
                                    'Content-Type': 'application/json',
                                }), body: JSON.stringify({ password: password }) }))];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    },
};

function activateAccount(action) {
    var authState, token, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                authState = _a.sent();
                if (!isLoggedInPasswordless(authState)) {
                    throw new Error('User needs to be logged-in with passwordless connection');
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 8]);
                return [4 /*yield*/, call(getToken, 'openid', 'email')];
            case 3:
                token = _a.sent();
                return [4 /*yield*/, call([account, 'activate'], authState.apiUrl, token, authState.userId, authState.email, action.payload.password, action.payload.consents)];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(setPasswordSuccess({
                        userId: authState.userId,
                        password: action.payload.password,
                        email: authState.email,
                        consents: action.payload.consents,
                    }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _a.sent();
                return [4 /*yield*/, put(setPasswordFailed(err_1))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function loginAfterAccountActivation(action) {
    var authState, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                authState = _a.sent();
                if (!isLoggedInPasswordless(authState)) {
                    return [2 /*return*/];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 7]);
                return [4 /*yield*/, put(loginWithPassword({
                        email: action.payload.email,
                        password: action.payload.password,
                    }))];
            case 3:
                _a.sent();
                return [4 /*yield*/, call(toast.success, 'account.setPassword.success')];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                err_2 = _a.sent();
                return [4 /*yield*/, put(setPasswordFailed(err_2))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function signupPasswordless(action) {
    var authState, _a, email, personalDetails, selectedOptIns, reason, optInUpdates, _b, protocol, host, redirectUri, result, err_3;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                authState = _c.sent();
                if (isUninitialized$1(authState)) {
                    throw new Error("Can't do signup when auth hasn't been initialized first");
                }
                _c.label = 2;
            case 2:
                _c.trys.push([2, 7, , 9]);
                _a = action.payload, email = _a.email, personalDetails = _a.personalDetails, selectedOptIns = _a.selectedOptIns, reason = _a.reason;
                return [4 /*yield*/, call(createOptInsUpdate, selectedOptIns)];
            case 3:
                optInUpdates = _c.sent();
                _b = window.location, protocol = _b.protocol, host = _b.host;
                redirectUri = protocol + "//" + host + "/" + authState.routing.basePath + "/callback";
                return [4 /*yield*/, call([account, 'signup'], authState.apiUrl, redirectUri, email, { personalDetails: personalDetails, optins: optInUpdates }, reason)];
            case 4:
                result = _c.sent();
                return [4 /*yield*/, put(signUpSuccess({
                        email: action.payload.email,
                        id: result.accountId,
                        accountDataToken: result.accountDataToken,
                    }))];
            case 5:
                _c.sent();
                return [4 /*yield*/, call(toast.success, 'account.activationEmail.success')];
            case 6:
                _c.sent();
                return [3 /*break*/, 9];
            case 7:
                err_3 = _c.sent();
                return [4 /*yield*/, put(signUpFailed(err_3))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
var createAccountSagas = [
    takeLatest(SET_PASSWORD$1, activateAccount),
    takeLatest(SET_PASSWORD_SUCCESS, loginAfterAccountActivation),
    takeLatest(SIGNUP, signupPasswordless),
];

function isExpiredLinkError(error) {
    if ('error' in error) {
        var description = error.error_description || error.errorDescription;
        if (description === null || description === void 0 ? void 0 : description.toLowerCase().includes('the verification code has expired')) {
            return true;
        }
        // For an already activated account we inform the user the same as for an expired link
        if (description === null || description === void 0 ? void 0 : description.toLowerCase().includes('wrong email or verification code')) {
            return true;
        }
    }
    return false;
}

function login(action) {
    var returnPath, e_1, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                returnPath = action.payload.returnPath;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, , 9]);
                if (!(window && returnPath)) return [3 /*break*/, 5];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, call([sessionStorage, 'setItem'], 'login_returnPath', returnPath)];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4:
                e_1 = _a.sent();
                console.error("Setting path to storage failed. Error: " + e_1);
                return [3 /*break*/, 5];
            case 5: return [4 /*yield*/, call(crossOriginAuthentication, action.payload.email, action.payload.password, {
                    scope: 'openid profile email',
                })];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                err_1 = _a.sent();
                return [4 /*yield*/, put(loginFailed(err_1))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
var stateSpec = Type.interface({
    accountVerificationMethod: optional(Type.string),
    email: optional(Type.string),
    targetAction: optional(Type.literal({
        forgotPassword: 1,
        signUp: 1,
    })),
});
function parseState(state) {
    try {
        var result = JSON.parse(state);
        return verify(stateSpec, result).value();
    }
    catch (err) {
        return undefined;
    }
}
function parseHash() {
    var state, hash, result, accountVerificationMethod, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                state = 'TODO:csrf';
                _b.label = 1;
            case 1:
                _b.trys.push([1, 6, , 8]);
                try {
                    hash = QueryString.parse(window.location.hash.substring(1));
                    if (hash.state) {
                        state = StringGuard.guard('hash.state', hash.state);
                    }
                }
                catch (e) {
                    console.error('Error while parsing URL hash:', e);
                }
                return [4 /*yield*/, call(parseHash$1, {
                        state: state,
                    })];
            case 2:
                result = _b.sent();
                if (!!result.accessToken) return [3 /*break*/, 4];
                return [4 /*yield*/, put(parseHashFailed(__assign({ error: new Error('No accessToken received after login') }, parseState(state))))];
            case 3:
                _b.sent();
                return [2 /*return*/];
            case 4:
                accountVerificationMethod = (_a = parseState(state)) === null || _a === void 0 ? void 0 : _a.accountVerificationMethod;
                return [4 /*yield*/, call(onAccessTokenReceived, result.accessToken, true, accountVerificationMethod)];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6:
                error_1 = _b.sent();
                return [4 /*yield*/, put(parseHashFailed(__assign({ error: error_1 }, parseState(state))))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function redirectAfterParseHash(action) {
    var routes, route, returnPath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload.redirect) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getFormattedRoutes)];
            case 1:
                routes = _a.sent();
                if (!routes) {
                    throw new Error('Need routes to redirect');
                }
                route = RouteKey.Profile;
                if (!(action.payload.type === 'passwordless')) return [3 /*break*/, 2];
                if (action.payload.hasActivatedAccount) {
                    route = RouteKey.SetPassword;
                }
                else if (action.payload.accountVerificationMethod === 'dateOfBirth') {
                    route = RouteKey.Verify;
                }
                else {
                    route = RouteKey.CreateAccount;
                }
                return [3 /*break*/, 6];
            case 2: return [4 /*yield*/, call([sessionStorage, 'getItem'], 'login_returnPath')];
            case 3:
                returnPath = _a.sent();
                if (!returnPath) return [3 /*break*/, 6];
                return [4 /*yield*/, put(goto({ path: decodeURIComponent(returnPath) }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, call([sessionStorage, 'removeItem'], 'login_returnPath')];
            case 5:
                _a.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, put(goto({ route: route }))];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * If the user comes in passwordless and the link has expired, redirect
 * to 'link-expired' so they can request a new link
 */
function redirectAfterFailedParseHash(action) {
    var routes, _a, error, targetAction, query, description, redirectRoute;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getFormattedRoutes)];
            case 1:
                routes = _b.sent();
                if (!routes) {
                    throw new Error('Need routes to redirect');
                }
                _a = action.payload, error = _a.error, targetAction = _a.targetAction;
                query = {};
                if ('error' in error) {
                    description = error.error_description || error.errorDescription;
                    if (description && description.startsWith('gv__')) {
                        query.error = description.substring('gv__'.length);
                    }
                }
                redirectRoute = RouteKey.Login;
                if (targetAction === 'forgotPassword' || targetAction === 'signUp') {
                    redirectRoute = RouteKey.LinkExpired;
                    query.targetAction = targetAction;
                }
                else if (isExpiredLinkError(error)) {
                    redirectRoute = RouteKey.LinkExpired;
                }
                return [4 /*yield*/, put(goto({
                        route: redirectRoute,
                        query: Object.keys(query).length > 0 ? QueryString.stringify(query, true) : undefined,
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function recoverSession() {
    var authState, result, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                authState = _a.sent();
                if (!isInitialized$1(authState)) {
                    return [2 /*return*/];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 9, , 12]);
                return [4 /*yield*/, call(checkSession, {
                        scope: 'openid profile',
                        responseType: 'id_token token',
                    })];
            case 3:
                result = _a.sent();
                if (!!result.accessToken) return [3 /*break*/, 6];
                return [4 /*yield*/, put(recoverSessionFailed(new Error('No accessToken received during session recovery')))];
            case 4:
                _a.sent();
                return [4 /*yield*/, call(DataLayer.setUserObjectDataLayer, false)];
            case 5:
                _a.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, call(onAccessTokenReceived, result.accessToken, false)];
            case 7:
                _a.sent();
                return [4 /*yield*/, call(DataLayer.setUserObjectDataLayer, true)];
            case 8:
                _a.sent();
                return [3 /*break*/, 12];
            case 9:
                err_2 = _a.sent();
                return [4 /*yield*/, put(recoverSessionFailed(err_2))];
            case 10:
                _a.sent();
                return [4 /*yield*/, call(DataLayer.setUserObjectDataLayer, false)];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function onAccessTokenReceived(accessToken, redirect, accountVerificationMethod) {
    var jwtContent, email, userInfo$1, opts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(jwtDecode, accessToken)];
            case 1:
                jwtContent = _a.sent();
                email = jwtContent['https://grandvision/claims/email'];
                if (!!email) return [3 /*break*/, 3];
                return [4 /*yield*/, call(userInfo, accessToken)];
            case 2:
                userInfo$1 = _a.sent();
                if (!userInfo$1.email) {
                    throw new Error("Email claim should be in accessToken or accessToken should have at least 'openid email' scope");
                }
                email = userInfo$1.email;
                _a.label = 3;
            case 3: return [4 /*yield*/, call(cacheToken, accessToken)];
            case 4:
                _a.sent();
                opts = {
                    id: jwtContent.sub,
                    email: email,
                    redirect: redirect,
                };
                if (!(jwtContent['https://grandvision/claims/connection'] === 'email')) return [3 /*break*/, 6];
                return [4 /*yield*/, put(parseHashSucceeded(__assign(__assign({}, opts), { type: 'passwordless', hasActivatedAccount: jwtContent['https://grandvision/claims/activeAccount'] || false, accountVerificationMethod: accountVerificationMethod })))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(parseHashSucceeded(__assign(__assign({}, opts), { type: 'regular' })))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
var loginSagas = [
    takeLatest(LOGIN, login),
    takeLatest(PARSE_HASH, parseHash),
    takeLatest(PARSE_HASH_SUCCEEDED, redirectAfterParseHash),
    takeLatest(PARSE_HASH_FAILED, redirectAfterFailedParseHash),
    takeLeading(RECOVER_SESSION, recoverSession),
];

function getReturnPath() {
    var _a = window.location, pathname = _a.pathname, search = _a.search, hash = _a.hash;
    return pathname + search + hash;
}
function logOut() {
    var basePath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getBasePath)];
            case 1:
                basePath = _a.sent();
                if (!basePath) {
                    throw new Error("Need basePath to generate logout return URI");
                }
                return [4 /*yield*/, call(logout, window.location.protocol + "//" + location.host + "/" + basePath + "/logged-out?returnPath=" + getReturnPath())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function redirectAfterLogOut() {
    var returnPath, targetPath, historyWrapper, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(removeUserDataFromLS)];
            case 1:
                _a.sent();
                returnPath = QueryString.parse(window.location.search).returnPath;
                targetPath = isString(returnPath) ? returnPath : '/';
                return [4 /*yield*/, call(history)];
            case 2:
                historyWrapper = _a.sent();
                _a.label = 3;
            case 3:
                _a.trys.push([3, 5, , 6]);
                return [4 /*yield*/, call(historyWrapper.replace, { pathname: targetPath })];
            case 4:
                _a.sent();
                window && window.location.reload();
                return [3 /*break*/, 6];
            case 5:
                err_1 = _a.sent();
                console.error(err_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
var logoutSagas = [
    takeLatest(LOG_OUT, logOut),
    takeLatest(LOGGED_OUT, redirectAfterLogOut),
];

function fetchOptIns() {
    var auth, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4 /*yield*/, select(getAuth)];
            case 1:
                auth = _a.sent();
                if (!isLoggedIn$1(auth)) {
                    throw new Error("Can't fetch opt-ins when user isn't logged in");
                }
                return [4 /*yield*/, call([optIns, 'fetch'], auth.apiUrl, auth.userId)];
            case 2:
                result = _a.sent();
                return [4 /*yield*/, put(fetchOptInsSuccess(result))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                err_1 = _a.sent();
                return [4 /*yield*/, put(fetchOptInsFailed(err_1))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function updateOptIns(action) {
    var auth, changedOptIns, updates, serverOptInsState_1, diff, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 11, , 13]);
                return [4 /*yield*/, select(getAuth)];
            case 1:
                auth = _a.sent();
                if (!isLoggedIn$1(auth)) {
                    throw new Error("Can't fetch opt-ins when user isn't logged in");
                }
                changedOptIns = action.payload;
                if (!(changedOptIns === undefined)) return [3 /*break*/, 3];
                return [4 /*yield*/, select(getChangedOptIns)];
            case 2:
                changedOptIns = _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, call(createOptInsUpdate, changedOptIns)];
            case 4:
                updates = _a.sent();
                if (!(Object.keys(updates).length > 0)) return [3 /*break*/, 10];
                return [4 /*yield*/, call([optIns, 'fetch'], auth.apiUrl, auth.userId)
                    // Diff what is actually an opt-in update
                ];
            case 5:
                serverOptInsState_1 = _a.sent();
                diff = Object.entries(updates).reduce(function (acc, _a) {
                    var _b;
                    var _c = __read(_a, 2), key = _c[0], optIn = _c[1];
                    return (serverOptInsState_1.optinValues || {})[key] !== optIn.value
                        ? __assign(__assign({}, acc), (_b = {}, _b[key] = optIn, _b)) : acc;
                }, {});
                if (!(Object.keys(diff).length > 0)) return [3 /*break*/, 7];
                return [4 /*yield*/, call([optIns, 'update'], auth.apiUrl, auth.userId, diff)];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [4 /*yield*/, put(updateOptInsSuccess())];
            case 8:
                _a.sent();
                return [4 /*yield*/, call(toast.success, 'account.updateOptins.success')];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11:
                err_2 = _a.sent();
                return [4 /*yield*/, put(updateOptInsFailed(err_2))];
            case 12:
                _a.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
var optInSagas = [
    takeLatest(FETCH_OPT_INS, fetchOptIns),
    takeLatest(UPDATE_OPT_INS, updateOptIns),
];

var getAuth0ErrorCode = function (errorString) {
    var regex = /"auth0ErrorCode":"(\w+)"/;
    var result = errorString.match(regex);
    return result && result[1] ? result[1] : undefined;
};

function onResetPassword(action) {
    var authState, stateParams, _a, protocol, host, redirectUri, requestPayload, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                authState = _b.sent();
                _b.label = 2;
            case 2:
                _b.trys.push([2, 6, , 8]);
                stateParams = {
                    targetAction: 'forgotPassword',
                };
                _a = window === null || window === void 0 ? void 0 : window.location, protocol = _a.protocol, host = _a.host;
                redirectUri = protocol + "//" + host + "/" + authState.routing.basePath + "/callback";
                requestPayload = {
                    emailAddress: action.payload.email,
                    state: JSON.stringify(stateParams),
                    loginRedirectUrl: redirectUri,
                };
                return [4 /*yield*/, call(Customers.Password.resetPassword, authState.apiUrl, requestPayload)];
            case 3:
                _b.sent();
                return [4 /*yield*/, put(resetPasswordSuccess({
                        email: action.payload.email,
                    }))];
            case 4:
                _b.sent();
                return [4 /*yield*/, call(toast.success, 'account.resetPassword.success')];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _b.sent();
                return [4 /*yield*/, put(resetPasswordFailed(err_1))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function onUpdatePassword(action) {
    var authState, token, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                authState = _a.sent();
                if (!!isLoggedInPasswordless(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(updatePasswordFailed(new Error("Can only update users' password when they're logged-in with passwordless link")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(getToken, 'gv::update:password', 'email', 'profile', 'openid')];
            case 4:
                token = _a.sent();
                _a.label = 5;
            case 5:
                _a.trys.push([5, 9, , 11]);
                return [4 /*yield*/, call(account.changePassword, authState.apiUrl, token, authState.userId, action.payload.password)];
            case 6:
                _a.sent();
                return [4 /*yield*/, put(updatePasswordSuccess({
                        password: action.payload.password,
                    }))];
            case 7:
                _a.sent();
                return [4 /*yield*/, call(toast.success, 'account.updatePassword.success')];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9:
                err_2 = _a.sent();
                return [4 /*yield*/, put(updatePasswordFailed(err_2))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
var convertPayload = function (payload) { return ({
    email: payload.email,
    oldPassword: payload.currentPassword,
    password: payload.newPassword,
}); };
function onChangePassword(action) {
    var authState, changePasswordPayload, token, err_3, auth0ErrorCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                authState = _a.sent();
                if (!!isLoggedIn$1(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(changePasswordFailed(new Error("Can only update users' password when they're logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                changePasswordPayload = convertPayload(action.payload);
                _a.label = 4;
            case 4:
                _a.trys.push([4, 8, , 10]);
                return [4 /*yield*/, call(getToken)];
            case 5:
                token = _a.sent();
                return [4 /*yield*/, call(Customers.Password.changePassword, authState.apiUrl, token, authState.userId, changePasswordPayload)];
            case 6:
                _a.sent();
                return [4 /*yield*/, put(changePasswordSuccess({
                        password: changePasswordPayload.password,
                    }))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_3 = _a.sent();
                auth0ErrorCode = (err_3 === null || err_3 === void 0 ? void 0 : err_3.message) ? getAuth0ErrorCode(err_3.message) : undefined;
                return [4 /*yield*/, put(changePasswordFailed(auth0ErrorCode || err_3))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function loginAfterPasswordUpdate(action) {
    var authState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                authState = _a.sent();
                if (!isLoggedInPasswordless(authState)) {
                    console.error("User is not logged in via passwordless method. Login state: " + authState.state + ". Login type: " + authState.type + ".");
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(crossOriginAuthentication, authState.email, action.payload.password)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function loginAfterPasswordChange(action) {
    var authState, routing, returnPath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                authState = _a.sent();
                return [4 /*yield*/, select(getRouting)];
            case 2:
                routing = _a.sent();
                if (!isLoggedIn$1(authState)) {
                    console.error("User is not regularly logged in. Login state: " + authState.state + ". Login type: " + authState.type + ".");
                    return [2 /*return*/];
                }
                returnPath = routing &&
                    encodeURIComponent(routing.basePath + '/' + routing.routes.changePassword + '?changePasswordResult=success');
                return [4 /*yield*/, put(loginWithPassword({
                        email: authState.email,
                        password: action.payload.password,
                        returnPath: returnPath,
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var resetPasswordSagas = [
    takeLatest(RESET_PASSWORD, onResetPassword),
    takeLatest(UPDATE_PASSWORD, onUpdatePassword),
    takeLatest(CHANGE_PASSWORD, onChangePassword),
    takeLatest(CHANGE_PASSWORD_SUCCESS, loginAfterPasswordChange),
    takeLatest(UPDATE_PASSWORD_SUCCESS, loginAfterPasswordUpdate),
];

function fetchUserData() {
    var auth, token, response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuth)];
            case 1:
                auth = _a.sent();
                if (!isLoggedIn$1(auth)) {
                    throw new Error("Can't fetch user data when not logged in");
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 8]);
                return [4 /*yield*/, call(getToken)];
            case 3:
                token = _a.sent();
                return [4 /*yield*/, call(Customers.details, auth.apiUrl, token, auth.userId)];
            case 4:
                response = _a.sent();
                return [4 /*yield*/, put(fetchUserDataSuccess(response.personalDetails))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _a.sent();
                return [4 /*yield*/, put(fetchUserDataFailed(err_1))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function updateUserData(action) {
    var _a, formName, formData, auth, userData, updatedUserData, token, err_2;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, formName = _a.formName, formData = _a.formData;
                return [4 /*yield*/, select(getAuth)];
            case 1:
                auth = _c.sent();
                return [4 /*yield*/, select(getUserData)];
            case 2:
                userData = _c.sent();
                if (!isLoggedIn$1(auth)) {
                    throw new Error("Can't fetch user data when not logged in");
                }
                if (!(userData && statusSuccess(userData))) return [3 /*break*/, 9];
                updatedUserData = __assign(__assign({}, userData.result), (_b = {}, _b[formName] = formData, _b));
                _c.label = 3;
            case 3:
                _c.trys.push([3, 7, , 9]);
                return [4 /*yield*/, call(getToken)];
            case 4:
                token = _c.sent();
                return [4 /*yield*/, call(Customers.updateDetails, auth.apiUrl, token, auth.userId, {
                        personalDetails: updatedUserData,
                    })];
            case 5:
                _c.sent();
                return [4 /*yield*/, put(updateUserDataSuccess({
                        server: updatedUserData,
                        formName: formName,
                    }))];
            case 6:
                _c.sent();
                return [3 /*break*/, 9];
            case 7:
                err_2 = _c.sent();
                return [4 /*yield*/, put(updateUserDataFailed({ error: err_2, formName: formName }))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
var userDataSagas = [
    takeLatest(FETCH_USER_DATA, fetchUserData),
    takeLatest(UPDATE_USER_DATA, updateUserData),
];

function authInit(action) {
    var _a, domain, customDomain, clientId, basePath;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, domain = _a.domain, customDomain = _a.customDomain, clientId = _a.clientId, basePath = _a.basePath;
                return [4 /*yield*/, call(init, {
                        clientID: clientId,
                        domain: customDomain || domain,
                        audience: 'fake_https://api.local:3080/',
                        redirectUri: window.location.protocol + "//" + window.location.host + "/" + basePath + "/callback",
                    })];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onGoto(action) {
    var pathname, routes, requestedRoute, historyWrapper;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!('path' in action.payload)) return [3 /*break*/, 2];
                pathname = ("/" + action.payload.path).replace('//', '/');
                return [4 /*yield*/, call(redirect, pathname)];
            case 1:
                _a.sent();
                return [2 /*return*/];
            case 2: return [4 /*yield*/, select(getFormattedRoutes)];
            case 3:
                routes = _a.sent();
                if (!routes) {
                    throw new Error('Need routes to redirect');
                }
                requestedRoute = routes[action.payload.route];
                if (!requestedRoute) {
                    throw new Error("Tried to go to optional route '" + action.payload.route + "' but it is not set. Formatted routes contained: '" + String(requestedRoute) + "'");
                }
                return [4 /*yield*/, call(history)];
            case 4:
                historyWrapper = _a.sent();
                if (!action.payload.query) return [3 /*break*/, 6];
                return [4 /*yield*/, call(historyWrapper.push, {
                        pathname: requestedRoute,
                        search: action.payload.query,
                    })];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, call(historyWrapper.push, { pathname: requestedRoute })];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
function sagas () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(createAccountSagas)), __read(loginSagas)), __read(logoutSagas)), __read(resetPasswordSagas)), __read(optInSagas)), __read(userDataSagas)), [
                    takeLatest(GOTO, onGoto),
                    takeLatest(INIT, authInit),
                ]))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

/**
 * Auth Module
 *
 * Contains all components related to users authentication
 *
 * @grandvisionhq/auth
 */
ReducersRegistry.register('auth', reducer);
SagaRegistry.register('auth', sagas);

export { actions as Actions, AuthContext, AuthContextConsumer, AuthProvider$1 as AuthProvider, Callback, index$1 as CreateAccount, ExpiredLink, LoggedIn$1 as LoggedIn, Login$1 as Login, MyAccountMenuContainer as MyAccountMenu, index as ResetPassword, RouteKey, selectors as Selectors, state as State, types as Types, index$2 as Utils, cacheToken, getMyAccountMenuItems, getToken, init$1 as init, optIns, useAccount };
//# sourceMappingURL=index.js.map
